import { jsxs as H, jsx as g, Fragment as ke } from "react/jsx-runtime";
import * as u from "react";
import le, { forwardRef as ye, isValidElement as fo, useState as St, Children as Ye, useLayoutEffect as ho, useEffect as It, useRef as De } from "react";
import * as Mr from "react-dom";
import mo from "react-dom";
const go = {
  LG: "lg"
};
function vo(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Qt = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var er;
function bo() {
  return er || (er = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var n = "", s = 0; s < arguments.length; s++) {
          var l = arguments[s];
          l && (n = i(n, o(l)));
        }
        return n;
      }
      function o(n) {
        if (typeof n == "string" || typeof n == "number")
          return n;
        if (typeof n != "object")
          return "";
        if (Array.isArray(n))
          return r.apply(null, n);
        if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]"))
          return n.toString();
        var s = "";
        for (var l in n)
          t.call(n, l) && n[l] && (s = i(s, l));
        return s;
      }
      function i(n, s) {
        return s ? n ? n + " " + s : n + s : n;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Qt)), Qt.exports;
}
var _o = bo();
const tr = /* @__PURE__ */ vo(_o), yo = "_rotate_1xozj_1", wo = "_dash_1xozj_1", Re = {
  "purpur-spinner": "_purpur-spinner_1xozj_1",
  rotate: yo,
  "purpur-spinner--xxs": "_purpur-spinner--xxs_1xozj_4",
  "purpur-spinner--xs": "_purpur-spinner--xs_1xozj_8",
  "purpur-spinner--sm": "_purpur-spinner--sm_1xozj_12",
  "purpur-spinner--md": "_purpur-spinner--md_1xozj_16",
  "purpur-spinner--lg": "_purpur-spinner--lg_1xozj_20",
  "purpur-spinner__circle": "_purpur-spinner__circle_1xozj_24",
  dash: wo,
  "purpur-spinner__circle--disabled": "_purpur-spinner__circle--disabled_1xozj_33",
  "purpur-spinner__circle--negative": "_purpur-spinner__circle--negative_1xozj_36"
}, Ee = "purpur-spinner", xo = {
  SM: "sm"
}, So = ({
  ["data-testid"]: e,
  disabled: t = !1,
  negative: r = !1,
  size: o = xo.SM,
  ...i
}) => /* @__PURE__ */ g(
  "div",
  {
    className: tr([Re[Ee], Re[`${Ee}--${o}`]]),
    "data-testid": e,
    ...i,
    children: /* @__PURE__ */ g("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ g(
      "circle",
      {
        className: tr(Re[`${Ee}__circle`], {
          [Re[`${Ee}__circle--disabled`]]: t,
          [Re[`${Ee}__circle--negative`]]: r
        }),
        cx: "25",
        cy: "25",
        r: "20"
      }
    ) })
  }
);
function Co(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var rr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var nr;
function Ro() {
  return nr || (nr = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var n = "", s = 0; s < arguments.length; s++) {
          var l = arguments[s];
          l && (n = i(n, o.call(this, l)));
        }
        return n;
      }
      function o(n) {
        if (typeof n == "string" || typeof n == "number")
          return this && this[n] || n;
        if (typeof n != "object")
          return "";
        if (Array.isArray(n))
          return r.apply(this, n);
        if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]"))
          return n.toString();
        var s = "";
        for (var l in n)
          t.call(n, l) && n[l] && (s = i(s, this && this[l] || l));
        return s;
      }
      function i(n, s) {
        return s ? n ? n + " " + s : n + s : n;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(rr)), rr.exports;
}
var Eo = Ro();
const Po = /* @__PURE__ */ Co(Eo), Ao = {
  "purpur-button": "_purpur-button_w455q_1",
  "purpur-button--xs": "_purpur-button--xs_w455q_33",
  "purpur-button--icon-only": "_purpur-button--icon-only_w455q_36",
  "purpur-button--sm": "_purpur-button--sm_w455q_39",
  "purpur-button--md": "_purpur-button--md_w455q_45",
  "purpur-button--lg": "_purpur-button--lg_w455q_51",
  "purpur-button--full-width": "_purpur-button--full-width_w455q_57",
  "purpur-button--primary": "_purpur-button--primary_w455q_60",
  "purpur-button--disabled": "_purpur-button--disabled_w455q_64",
  "purpur-button--primary-negative": "_purpur-button--primary-negative_w455q_70",
  "purpur-button--secondary": "_purpur-button--secondary_w455q_82",
  "purpur-button--secondary-negative": "_purpur-button--secondary-negative_w455q_93",
  "purpur-button--expressive": "_purpur-button--expressive_w455q_104",
  "purpur-button--expressive-negative": "_purpur-button--expressive-negative_w455q_114",
  "purpur-button--negative": "_purpur-button--negative_w455q_126",
  "purpur-button--destructive": "_purpur-button--destructive_w455q_133",
  "purpur-button--destructive-negative": "_purpur-button--destructive-negative_w455q_143",
  "purpur-button--tertiary-purple": "_purpur-button--tertiary-purple_w455q_153",
  "purpur-button--tertiary-purple-negative": "_purpur-button--tertiary-purple-negative_w455q_166",
  "purpur-button--text-negative": "_purpur-button--text-negative_w455q_181",
  "purpur-button--text": "_purpur-button--text_w455q_181"
}, Ct = {
  TERTIARY_PURPLE: "tertiary-purple"
}, To = Po.bind(Ao), ae = "purpur-button", No = ({
  children: e,
  className: t,
  ["data-testid"]: r,
  disabled: o = !1,
  fullWidth: i = !1,
  iconOnly: n,
  loading: s = !1,
  negative: l = !1,
  onClick: a,
  size: c = "md",
  variant: p,
  type: d = "button",
  ...h
}, f) => {
  if (n && p === "destructive")
    return null;
  const m = To(
    [
      ae,
      `${ae}--${l ? `${p}-negative` : p}`,
      `${ae}--${c}`
    ],
    {
      [`${ae}--icon-only`]: n,
      [`${ae}--negative`]: l,
      [`${ae}--full-width`]: i,
      [`${ae}--disabled`]: o || s
    },
    t
  ), v = (b) => {
    o || s ? b.preventDefault() : a && a(b);
  }, _ = !!h["aria-disabled"] || o || s;
  return /* @__PURE__ */ H(
    "button",
    {
      className: m,
      "data-testid": r,
      type: d,
      ref: f,
      "aria-disabled": _,
      onClick: v,
      ...h,
      children: [
        s && /* @__PURE__ */ g(So, { size: c === go.LG ? "xs" : "xxs", negative: l, disabled: _ }),
        " ",
        e
      ]
    }
  );
}, Ge = ye(No);
Ge.displayName = "Button";
function Oo(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var or = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var ir;
function Lo() {
  return ir || (ir = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var n = "", s = 0; s < arguments.length; s++) {
          var l = arguments[s];
          l && (n = i(n, o.call(this, l)));
        }
        return n;
      }
      function o(n) {
        if (typeof n == "string" || typeof n == "number")
          return this && this[n] || n;
        if (typeof n != "object")
          return "";
        if (Array.isArray(n))
          return r.apply(this, n);
        if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]"))
          return n.toString();
        var s = "";
        for (var l in n)
          t.call(n, l) && n[l] && (s = i(s, this && this[l] || l));
        return s;
      }
      function i(n, s) {
        return s ? n ? n + " " + s : n + s : n;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(or)), or.exports;
}
var $o = Lo();
const Do = /* @__PURE__ */ Oo($o), Io = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, Mo = Do.bind(Io), sr = "purpur-icon", ko = "md", Fo = (e) => e.filter((t) => Object.keys(t).length >= 1).map((t) => `${t.name}="${t.value}"`).join(" "), Wo = ({ content: e = "", title: t } = {}) => {
  const r = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    t ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], o = t ? `<title>${t}</title>` : "";
  return `<svg ${Fo(r)}>${o}${e}</svg>`;
}, jo = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), it = ({
  ["data-testid"]: e,
  svg: t,
  allyTitle: r,
  className: o,
  size: i = ko,
  ...n
}) => {
  const s = Wo({
    content: jo(t.svg),
    title: r
  }), l = Mo(o, sr, `${sr}--${i}`);
  return /* @__PURE__ */ g(
    "span",
    {
      className: l,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: s },
      ...n
    }
  );
};
it.displayName = "Icon";
const zo = {
  name: "chevron-left",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M16.175 3.905a.9.9 0 0 1-.08 1.27L8.36 12l7.736 6.825a.9.9 0 0 1-1.191 1.35l-8.5-7.5a.9.9 0 0 1 0-1.35l8.5-7.5a.9.9 0 0 1 1.27.08Z" clip-rule="evenodd"/></svg>',
  keywords: ["chevron-left"],
  category: "utility"
}, kr = (e) => /* @__PURE__ */ g(it, { ...e, svg: zo });
kr.displayName = "IconChevronLeft";
const Bo = {
  name: "chevron-right",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M7.809 3.924a.9.9 0 0 0 .115 1.267L16.094 12l-8.17 6.809a.9.9 0 0 0 1.152 1.382l9-7.5a.9.9 0 0 0 0-1.382l-9-7.5a.9.9 0 0 0-1.267.115Z" clip-rule="evenodd"/></svg>',
  keywords: ["chevron-right"],
  category: "utility"
}, Fr = (e) => /* @__PURE__ */ g(it, { ...e, svg: Bo });
Fr.displayName = "IconChevronRight";
function W(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), r === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function Mt(e, t = []) {
  let r = [];
  function o(n, s) {
    const l = u.createContext(s), a = r.length;
    r = [...r, s];
    const c = (d) => {
      var b;
      const { scope: h, children: f, ...m } = d, v = ((b = h == null ? void 0 : h[e]) == null ? void 0 : b[a]) || l, _ = u.useMemo(() => m, Object.values(m));
      return /* @__PURE__ */ g(v.Provider, { value: _, children: f });
    };
    c.displayName = n + "Provider";
    function p(d, h) {
      var v;
      const f = ((v = h == null ? void 0 : h[e]) == null ? void 0 : v[a]) || l, m = u.useContext(f);
      if (m) return m;
      if (s !== void 0) return s;
      throw new Error(`\`${d}\` must be used within \`${n}\``);
    }
    return [c, p];
  }
  const i = () => {
    const n = r.map((s) => u.createContext(s));
    return function(l) {
      const a = (l == null ? void 0 : l[e]) || n;
      return u.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: a } }),
        [l, a]
      );
    };
  };
  return i.scopeName = e, [o, Ho(i, ...t)];
}
function Ho(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const o = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(n) {
      const s = o.reduce((l, { useScope: a, scopeName: c }) => {
        const d = a(n)[`__scope${c}`];
        return { ...l, ...d };
      }, {});
      return u.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
function lr(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Wr(...e) {
  return (t) => {
    let r = !1;
    const o = e.map((i) => {
      const n = lr(i, t);
      return !r && typeof n == "function" && (r = !0), n;
    });
    if (r)
      return () => {
        for (let i = 0; i < o.length; i++) {
          const n = o[i];
          typeof n == "function" ? n() : lr(e[i], null);
        }
      };
  };
}
function G(...e) {
  return u.useCallback(Wr(...e), e);
}
var Ke = u.forwardRef((e, t) => {
  const { children: r, ...o } = e, i = u.Children.toArray(r), n = i.find(Uo);
  if (n) {
    const s = n.props.children, l = i.map((a) => a === n ? u.Children.count(s) > 1 ? u.Children.only(null) : u.isValidElement(s) ? s.props.children : null : a);
    return /* @__PURE__ */ g(Rt, { ...o, ref: t, children: u.isValidElement(s) ? u.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ g(Rt, { ...o, ref: t, children: r });
});
Ke.displayName = "Slot";
var Rt = u.forwardRef((e, t) => {
  const { children: r, ...o } = e;
  if (u.isValidElement(r)) {
    const i = Yo(r), n = Vo(o, r.props);
    return r.type !== u.Fragment && (n.ref = t ? Wr(t, i) : i), u.cloneElement(r, n);
  }
  return u.Children.count(r) > 1 ? u.Children.only(null) : null;
});
Rt.displayName = "SlotClone";
var qo = ({ children: e }) => /* @__PURE__ */ g(ke, { children: e });
function Uo(e) {
  return u.isValidElement(e) && e.type === qo;
}
function Vo(e, t) {
  const r = { ...t };
  for (const o in t) {
    const i = e[o], n = t[o];
    /^on[A-Z]/.test(o) ? i && n ? r[o] = (...l) => {
      n(...l), i(...l);
    } : i && (r[o] = i) : o === "style" ? r[o] = { ...i, ...n } : o === "className" && (r[o] = [i, n].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function Yo(e) {
  var o, i;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
function Xo(e) {
  const t = e + "CollectionProvider", [r, o] = Mt(t), [i, n] = r(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (f) => {
    const { scope: m, children: v } = f, _ = le.useRef(null), b = le.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ g(i, { scope: m, itemMap: b, collectionRef: _, children: v });
  };
  s.displayName = t;
  const l = e + "CollectionSlot", a = le.forwardRef(
    (f, m) => {
      const { scope: v, children: _ } = f, b = n(l, v), y = G(m, b.collectionRef);
      return /* @__PURE__ */ g(Ke, { ref: y, children: _ });
    }
  );
  a.displayName = l;
  const c = e + "CollectionItemSlot", p = "data-radix-collection-item", d = le.forwardRef(
    (f, m) => {
      const { scope: v, children: _, ...b } = f, y = le.useRef(null), x = G(m, y), w = n(c, v);
      return le.useEffect(() => (w.itemMap.set(y, { ref: y, ...b }), () => void w.itemMap.delete(y))), /* @__PURE__ */ g(Ke, { [p]: "", ref: x, children: _ });
    }
  );
  d.displayName = c;
  function h(f) {
    const m = n(e + "CollectionConsumer", f);
    return le.useCallback(() => {
      const _ = m.collectionRef.current;
      if (!_) return [];
      const b = Array.from(_.querySelectorAll(`[${p}]`));
      return Array.from(m.itemMap.values()).sort(
        (w, S) => b.indexOf(w.ref.current) - b.indexOf(S.ref.current)
      );
    }, [m.collectionRef, m.itemMap]);
  }
  return [
    { Provider: s, Slot: a, ItemSlot: d },
    h,
    o
  ];
}
var Ze = globalThis != null && globalThis.document ? u.useLayoutEffect : () => {
}, Go = u.useId || (() => {
}), Ko = 0;
function Zo(e) {
  const [t, r] = u.useState(Go());
  return Ze(() => {
    r((o) => o ?? String(Ko++));
  }, [e]), t ? `radix-${t}` : "";
}
var Jo = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], de = Jo.reduce((e, t) => {
  const r = u.forwardRef((o, i) => {
    const { asChild: n, ...s } = o, l = n ? Ke : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(l, { ...s, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Y(e) {
  const t = u.useRef(e);
  return u.useEffect(() => {
    t.current = e;
  }), u.useMemo(() => (...r) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...r);
  }, []);
}
function Qo({
  prop: e,
  defaultProp: t,
  onChange: r = () => {
  }
}) {
  const [o, i] = ei({ defaultProp: t, onChange: r }), n = e !== void 0, s = n ? e : o, l = Y(r), a = u.useCallback(
    (c) => {
      if (n) {
        const d = typeof c == "function" ? c(e) : c;
        d !== e && l(d);
      } else
        i(c);
    },
    [n, e, i, l]
  );
  return [s, a];
}
function ei({
  defaultProp: e,
  onChange: t
}) {
  const r = u.useState(e), [o] = r, i = u.useRef(o), n = Y(t);
  return u.useEffect(() => {
    i.current !== o && (n(o), i.current = o);
  }, [o, i, n]), r;
}
var ti = u.createContext(void 0);
function jr(e) {
  const t = u.useContext(ti);
  return e || t || "ltr";
}
var vt = "rovingFocusGroup.onEntryFocus", ri = { bubbles: !1, cancelable: !0 }, st = "RovingFocusGroup", [Et, zr, ni] = Xo(st), [oi, Ja] = Mt(
  st,
  [ni]
), [ii, si] = oi(st), Br = u.forwardRef(
  (e, t) => /* @__PURE__ */ g(Et.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ g(Et.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ g(li, { ...e, ref: t }) }) })
);
Br.displayName = st;
var li = u.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: r,
    orientation: o,
    loop: i = !1,
    dir: n,
    currentTabStopId: s,
    defaultCurrentTabStopId: l,
    onCurrentTabStopIdChange: a,
    onEntryFocus: c,
    preventScrollOnEntryFocus: p = !1,
    ...d
  } = e, h = u.useRef(null), f = G(t, h), m = jr(n), [v = null, _] = Qo({
    prop: s,
    defaultProp: l,
    onChange: a
  }), [b, y] = u.useState(!1), x = Y(c), w = zr(r), S = u.useRef(!1), [A, C] = u.useState(0);
  return u.useEffect(() => {
    const P = h.current;
    if (P)
      return P.addEventListener(vt, x), () => P.removeEventListener(vt, x);
  }, [x]), /* @__PURE__ */ g(
    ii,
    {
      scope: r,
      orientation: o,
      dir: m,
      loop: i,
      currentTabStopId: v,
      onItemFocus: u.useCallback(
        (P) => _(P),
        [_]
      ),
      onItemShiftTab: u.useCallback(() => y(!0), []),
      onFocusableItemAdd: u.useCallback(
        () => C((P) => P + 1),
        []
      ),
      onFocusableItemRemove: u.useCallback(
        () => C((P) => P - 1),
        []
      ),
      children: /* @__PURE__ */ g(
        de.div,
        {
          tabIndex: b || A === 0 ? -1 : 0,
          "data-orientation": o,
          ...d,
          ref: f,
          style: { outline: "none", ...e.style },
          onMouseDown: W(e.onMouseDown, () => {
            S.current = !0;
          }),
          onFocus: W(e.onFocus, (P) => {
            const R = !S.current;
            if (P.target === P.currentTarget && R && !b) {
              const E = new CustomEvent(vt, ri);
              if (P.currentTarget.dispatchEvent(E), !E.defaultPrevented) {
                const N = w().filter(($) => $.focusable), O = N.find(($) => $.active), k = N.find(($) => $.id === v), I = [O, k, ...N].filter(
                  Boolean
                ).map(($) => $.ref.current);
                Ur(I, p);
              }
            }
            S.current = !1;
          }),
          onBlur: W(e.onBlur, () => y(!1))
        }
      )
    }
  );
}), Hr = "RovingFocusGroupItem", qr = u.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: r,
      focusable: o = !0,
      active: i = !1,
      tabStopId: n,
      ...s
    } = e, l = Zo(), a = n || l, c = si(Hr, r), p = c.currentTabStopId === a, d = zr(r), { onFocusableItemAdd: h, onFocusableItemRemove: f } = c;
    return u.useEffect(() => {
      if (o)
        return h(), () => f();
    }, [o, h, f]), /* @__PURE__ */ g(
      Et.ItemSlot,
      {
        scope: r,
        id: a,
        focusable: o,
        active: i,
        children: /* @__PURE__ */ g(
          de.span,
          {
            tabIndex: p ? 0 : -1,
            "data-orientation": c.orientation,
            ...s,
            ref: t,
            onMouseDown: W(e.onMouseDown, (m) => {
              o ? c.onItemFocus(a) : m.preventDefault();
            }),
            onFocus: W(e.onFocus, () => c.onItemFocus(a)),
            onKeyDown: W(e.onKeyDown, (m) => {
              if (m.key === "Tab" && m.shiftKey) {
                c.onItemShiftTab();
                return;
              }
              if (m.target !== m.currentTarget) return;
              const v = ci(m, c.orientation, c.dir);
              if (v !== void 0) {
                if (m.metaKey || m.ctrlKey || m.altKey || m.shiftKey) return;
                m.preventDefault();
                let b = d().filter((y) => y.focusable).map((y) => y.ref.current);
                if (v === "last") b.reverse();
                else if (v === "prev" || v === "next") {
                  v === "prev" && b.reverse();
                  const y = b.indexOf(m.currentTarget);
                  b = c.loop ? pi(b, y + 1) : b.slice(y + 1);
                }
                setTimeout(() => Ur(b));
              }
            })
          }
        )
      }
    );
  }
);
qr.displayName = Hr;
var ai = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function ui(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function ci(e, t, r) {
  const o = ui(e.key, r);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return ai[o];
}
function Ur(e, t = !1) {
  const r = document.activeElement;
  for (const o of e)
    if (o === r || (o.focus({ preventScroll: t }), document.activeElement !== r)) return;
}
function pi(e, t) {
  return e.map((r, o) => e[(t + o) % e.length]);
}
var Vr = Br, di = qr;
function fi(e, t) {
  return u.useReducer((r, o) => t[r][o] ?? r, e);
}
var Fe = (e) => {
  const { present: t, children: r } = e, o = hi(t), i = typeof r == "function" ? r({ present: o.isPresent }) : u.Children.only(r), n = G(o.ref, mi(i));
  return typeof r == "function" || o.isPresent ? u.cloneElement(i, { ref: n }) : null;
};
Fe.displayName = "Presence";
function hi(e) {
  const [t, r] = u.useState(), o = u.useRef({}), i = u.useRef(e), n = u.useRef("none"), s = e ? "mounted" : "unmounted", [l, a] = fi(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return u.useEffect(() => {
    const c = He(o.current);
    n.current = l === "mounted" ? c : "none";
  }, [l]), Ze(() => {
    const c = o.current, p = i.current;
    if (p !== e) {
      const h = n.current, f = He(c);
      e ? a("MOUNT") : f === "none" || (c == null ? void 0 : c.display) === "none" ? a("UNMOUNT") : a(p && h !== f ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, a]), Ze(() => {
    if (t) {
      let c;
      const p = t.ownerDocument.defaultView ?? window, d = (f) => {
        const v = He(o.current).includes(f.animationName);
        if (f.target === t && v && (a("ANIMATION_END"), !i.current)) {
          const _ = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = p.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = _);
          });
        }
      }, h = (f) => {
        f.target === t && (n.current = He(o.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        p.clearTimeout(c), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      a("ANIMATION_END");
  }, [t, a]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: u.useCallback((c) => {
      c && (o.current = getComputedStyle(c)), r(c);
    }, [])
  };
}
function He(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function mi(e) {
  var o, i;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
function gi(e, [t, r]) {
  return Math.min(r, Math.max(t, e));
}
function vi(e, t) {
  return u.useReducer((r, o) => t[r][o] ?? r, e);
}
var kt = "ScrollArea", [Yr, Qa] = Mt(kt), [bi, q] = Yr(kt), Xr = u.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: r,
      type: o = "hover",
      dir: i,
      scrollHideDelay: n = 600,
      ...s
    } = e, [l, a] = u.useState(null), [c, p] = u.useState(null), [d, h] = u.useState(null), [f, m] = u.useState(null), [v, _] = u.useState(null), [b, y] = u.useState(0), [x, w] = u.useState(0), [S, A] = u.useState(!1), [C, P] = u.useState(!1), R = G(t, (N) => a(N)), E = jr(i);
    return /* @__PURE__ */ g(
      bi,
      {
        scope: r,
        type: o,
        dir: E,
        scrollHideDelay: n,
        scrollArea: l,
        viewport: c,
        onViewportChange: p,
        content: d,
        onContentChange: h,
        scrollbarX: f,
        onScrollbarXChange: m,
        scrollbarXEnabled: S,
        onScrollbarXEnabledChange: A,
        scrollbarY: v,
        onScrollbarYChange: _,
        scrollbarYEnabled: C,
        onScrollbarYEnabledChange: P,
        onCornerWidthChange: y,
        onCornerHeightChange: w,
        children: /* @__PURE__ */ g(
          de.div,
          {
            dir: E,
            ...s,
            ref: R,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": b + "px",
              "--radix-scroll-area-corner-height": x + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
Xr.displayName = kt;
var Gr = "ScrollAreaViewport", Kr = u.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: r, children: o, nonce: i, ...n } = e, s = q(Gr, r), l = u.useRef(null), a = G(t, l, s.onViewportChange);
    return /* @__PURE__ */ H(ke, { children: [
      /* @__PURE__ */ g(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: i
        }
      ),
      /* @__PURE__ */ g(
        de.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...n,
          ref: a,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: s.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: s.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ g("div", { ref: s.onContentChange, style: { minWidth: "100%", display: "table" }, children: o })
        }
      )
    ] });
  }
);
Kr.displayName = Gr;
var Z = "ScrollAreaScrollbar", Zr = u.forwardRef(
  (e, t) => {
    const { forceMount: r, ...o } = e, i = q(Z, e.__scopeScrollArea), { onScrollbarXEnabledChange: n, onScrollbarYEnabledChange: s } = i, l = e.orientation === "horizontal";
    return u.useEffect(() => (l ? n(!0) : s(!0), () => {
      l ? n(!1) : s(!1);
    }), [l, n, s]), i.type === "hover" ? /* @__PURE__ */ g(_i, { ...o, ref: t, forceMount: r }) : i.type === "scroll" ? /* @__PURE__ */ g(yi, { ...o, ref: t, forceMount: r }) : i.type === "auto" ? /* @__PURE__ */ g(Jr, { ...o, ref: t, forceMount: r }) : i.type === "always" ? /* @__PURE__ */ g(Ft, { ...o, ref: t }) : null;
  }
);
Zr.displayName = Z;
var _i = u.forwardRef((e, t) => {
  const { forceMount: r, ...o } = e, i = q(Z, e.__scopeScrollArea), [n, s] = u.useState(!1);
  return u.useEffect(() => {
    const l = i.scrollArea;
    let a = 0;
    if (l) {
      const c = () => {
        window.clearTimeout(a), s(!0);
      }, p = () => {
        a = window.setTimeout(() => s(!1), i.scrollHideDelay);
      };
      return l.addEventListener("pointerenter", c), l.addEventListener("pointerleave", p), () => {
        window.clearTimeout(a), l.removeEventListener("pointerenter", c), l.removeEventListener("pointerleave", p);
      };
    }
  }, [i.scrollArea, i.scrollHideDelay]), /* @__PURE__ */ g(Fe, { present: r || n, children: /* @__PURE__ */ g(
    Jr,
    {
      "data-state": n ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), yi = u.forwardRef((e, t) => {
  const { forceMount: r, ...o } = e, i = q(Z, e.__scopeScrollArea), n = e.orientation === "horizontal", s = at(() => a("SCROLL_END"), 100), [l, a] = vi("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return u.useEffect(() => {
    if (l === "idle") {
      const c = window.setTimeout(() => a("HIDE"), i.scrollHideDelay);
      return () => window.clearTimeout(c);
    }
  }, [l, i.scrollHideDelay, a]), u.useEffect(() => {
    const c = i.viewport, p = n ? "scrollLeft" : "scrollTop";
    if (c) {
      let d = c[p];
      const h = () => {
        const f = c[p];
        d !== f && (a("SCROLL"), s()), d = f;
      };
      return c.addEventListener("scroll", h), () => c.removeEventListener("scroll", h);
    }
  }, [i.viewport, n, a, s]), /* @__PURE__ */ g(Fe, { present: r || l !== "hidden", children: /* @__PURE__ */ g(
    Ft,
    {
      "data-state": l === "hidden" ? "hidden" : "visible",
      ...o,
      ref: t,
      onPointerEnter: W(e.onPointerEnter, () => a("POINTER_ENTER")),
      onPointerLeave: W(e.onPointerLeave, () => a("POINTER_LEAVE"))
    }
  ) });
}), Jr = u.forwardRef((e, t) => {
  const r = q(Z, e.__scopeScrollArea), { forceMount: o, ...i } = e, [n, s] = u.useState(!1), l = e.orientation === "horizontal", a = at(() => {
    if (r.viewport) {
      const c = r.viewport.offsetWidth < r.viewport.scrollWidth, p = r.viewport.offsetHeight < r.viewport.scrollHeight;
      s(l ? c : p);
    }
  }, 10);
  return ve(r.viewport, a), ve(r.content, a), /* @__PURE__ */ g(Fe, { present: o || n, children: /* @__PURE__ */ g(
    Ft,
    {
      "data-state": n ? "visible" : "hidden",
      ...i,
      ref: t
    }
  ) });
}), Ft = u.forwardRef((e, t) => {
  const { orientation: r = "vertical", ...o } = e, i = q(Z, e.__scopeScrollArea), n = u.useRef(null), s = u.useRef(0), [l, a] = u.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), c = rn(l.viewport, l.content), p = {
    ...o,
    sizes: l,
    onSizesChange: a,
    hasThumb: c > 0 && c < 1,
    onThumbChange: (h) => n.current = h,
    onThumbPointerUp: () => s.current = 0,
    onThumbPointerDown: (h) => s.current = h
  };
  function d(h, f) {
    return Pi(h, s.current, l, f);
  }
  return r === "horizontal" ? /* @__PURE__ */ g(
    wi,
    {
      ...p,
      ref: t,
      onThumbPositionChange: () => {
        if (i.viewport && n.current) {
          const h = i.viewport.scrollLeft, f = ar(h, l, i.dir);
          n.current.style.transform = `translate3d(${f}px, 0, 0)`;
        }
      },
      onWheelScroll: (h) => {
        i.viewport && (i.viewport.scrollLeft = h);
      },
      onDragScroll: (h) => {
        i.viewport && (i.viewport.scrollLeft = d(h, i.dir));
      }
    }
  ) : r === "vertical" ? /* @__PURE__ */ g(
    xi,
    {
      ...p,
      ref: t,
      onThumbPositionChange: () => {
        if (i.viewport && n.current) {
          const h = i.viewport.scrollTop, f = ar(h, l);
          n.current.style.transform = `translate3d(0, ${f}px, 0)`;
        }
      },
      onWheelScroll: (h) => {
        i.viewport && (i.viewport.scrollTop = h);
      },
      onDragScroll: (h) => {
        i.viewport && (i.viewport.scrollTop = d(h));
      }
    }
  ) : null;
}), wi = u.forwardRef((e, t) => {
  const { sizes: r, onSizesChange: o, ...i } = e, n = q(Z, e.__scopeScrollArea), [s, l] = u.useState(), a = u.useRef(null), c = G(t, a, n.onScrollbarXChange);
  return u.useEffect(() => {
    a.current && l(getComputedStyle(a.current));
  }, [a]), /* @__PURE__ */ g(
    en,
    {
      "data-orientation": "horizontal",
      ...i,
      ref: c,
      sizes: r,
      style: {
        bottom: 0,
        left: n.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: n.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": lt(r) + "px",
        ...e.style
      },
      onThumbPointerDown: (p) => e.onThumbPointerDown(p.x),
      onDragScroll: (p) => e.onDragScroll(p.x),
      onWheelScroll: (p, d) => {
        if (n.viewport) {
          const h = n.viewport.scrollLeft + p.deltaX;
          e.onWheelScroll(h), on(h, d) && p.preventDefault();
        }
      },
      onResize: () => {
        a.current && n.viewport && s && o({
          content: n.viewport.scrollWidth,
          viewport: n.viewport.offsetWidth,
          scrollbar: {
            size: a.current.clientWidth,
            paddingStart: Qe(s.paddingLeft),
            paddingEnd: Qe(s.paddingRight)
          }
        });
      }
    }
  );
}), xi = u.forwardRef((e, t) => {
  const { sizes: r, onSizesChange: o, ...i } = e, n = q(Z, e.__scopeScrollArea), [s, l] = u.useState(), a = u.useRef(null), c = G(t, a, n.onScrollbarYChange);
  return u.useEffect(() => {
    a.current && l(getComputedStyle(a.current));
  }, [a]), /* @__PURE__ */ g(
    en,
    {
      "data-orientation": "vertical",
      ...i,
      ref: c,
      sizes: r,
      style: {
        top: 0,
        right: n.dir === "ltr" ? 0 : void 0,
        left: n.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": lt(r) + "px",
        ...e.style
      },
      onThumbPointerDown: (p) => e.onThumbPointerDown(p.y),
      onDragScroll: (p) => e.onDragScroll(p.y),
      onWheelScroll: (p, d) => {
        if (n.viewport) {
          const h = n.viewport.scrollTop + p.deltaY;
          e.onWheelScroll(h), on(h, d) && p.preventDefault();
        }
      },
      onResize: () => {
        a.current && n.viewport && s && o({
          content: n.viewport.scrollHeight,
          viewport: n.viewport.offsetHeight,
          scrollbar: {
            size: a.current.clientHeight,
            paddingStart: Qe(s.paddingTop),
            paddingEnd: Qe(s.paddingBottom)
          }
        });
      }
    }
  );
}), [Si, Qr] = Yr(Z), en = u.forwardRef((e, t) => {
  const {
    __scopeScrollArea: r,
    sizes: o,
    hasThumb: i,
    onThumbChange: n,
    onThumbPointerUp: s,
    onThumbPointerDown: l,
    onThumbPositionChange: a,
    onDragScroll: c,
    onWheelScroll: p,
    onResize: d,
    ...h
  } = e, f = q(Z, r), [m, v] = u.useState(null), _ = G(t, (R) => v(R)), b = u.useRef(null), y = u.useRef(""), x = f.viewport, w = o.content - o.viewport, S = Y(p), A = Y(a), C = at(d, 10);
  function P(R) {
    if (b.current) {
      const E = R.clientX - b.current.left, N = R.clientY - b.current.top;
      c({ x: E, y: N });
    }
  }
  return u.useEffect(() => {
    const R = (E) => {
      const N = E.target;
      (m == null ? void 0 : m.contains(N)) && S(E, w);
    };
    return document.addEventListener("wheel", R, { passive: !1 }), () => document.removeEventListener("wheel", R, { passive: !1 });
  }, [x, m, w, S]), u.useEffect(A, [o, A]), ve(m, C), ve(f.content, C), /* @__PURE__ */ g(
    Si,
    {
      scope: r,
      scrollbar: m,
      hasThumb: i,
      onThumbChange: Y(n),
      onThumbPointerUp: Y(s),
      onThumbPositionChange: A,
      onThumbPointerDown: Y(l),
      children: /* @__PURE__ */ g(
        de.div,
        {
          ...h,
          ref: _,
          style: { position: "absolute", ...h.style },
          onPointerDown: W(e.onPointerDown, (R) => {
            R.button === 0 && (R.target.setPointerCapture(R.pointerId), b.current = m.getBoundingClientRect(), y.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", f.viewport && (f.viewport.style.scrollBehavior = "auto"), P(R));
          }),
          onPointerMove: W(e.onPointerMove, P),
          onPointerUp: W(e.onPointerUp, (R) => {
            const E = R.target;
            E.hasPointerCapture(R.pointerId) && E.releasePointerCapture(R.pointerId), document.body.style.webkitUserSelect = y.current, f.viewport && (f.viewport.style.scrollBehavior = ""), b.current = null;
          })
        }
      )
    }
  );
}), Je = "ScrollAreaThumb", tn = u.forwardRef(
  (e, t) => {
    const { forceMount: r, ...o } = e, i = Qr(Je, e.__scopeScrollArea);
    return /* @__PURE__ */ g(Fe, { present: r || i.hasThumb, children: /* @__PURE__ */ g(Ci, { ref: t, ...o }) });
  }
), Ci = u.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: r, style: o, ...i } = e, n = q(Je, r), s = Qr(Je, r), { onThumbPositionChange: l } = s, a = G(
      t,
      (d) => s.onThumbChange(d)
    ), c = u.useRef(void 0), p = at(() => {
      c.current && (c.current(), c.current = void 0);
    }, 100);
    return u.useEffect(() => {
      const d = n.viewport;
      if (d) {
        const h = () => {
          if (p(), !c.current) {
            const f = Ai(d, l);
            c.current = f, l();
          }
        };
        return l(), d.addEventListener("scroll", h), () => d.removeEventListener("scroll", h);
      }
    }, [n.viewport, p, l]), /* @__PURE__ */ g(
      de.div,
      {
        "data-state": s.hasThumb ? "visible" : "hidden",
        ...i,
        ref: a,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...o
        },
        onPointerDownCapture: W(e.onPointerDownCapture, (d) => {
          const f = d.target.getBoundingClientRect(), m = d.clientX - f.left, v = d.clientY - f.top;
          s.onThumbPointerDown({ x: m, y: v });
        }),
        onPointerUp: W(e.onPointerUp, s.onThumbPointerUp)
      }
    );
  }
);
tn.displayName = Je;
var Wt = "ScrollAreaCorner", Ri = u.forwardRef(
  (e, t) => {
    const r = q(Wt, e.__scopeScrollArea), o = !!(r.scrollbarX && r.scrollbarY);
    return r.type !== "scroll" && o ? /* @__PURE__ */ g(Ei, { ...e, ref: t }) : null;
  }
);
Ri.displayName = Wt;
var Ei = u.forwardRef((e, t) => {
  const { __scopeScrollArea: r, ...o } = e, i = q(Wt, r), [n, s] = u.useState(0), [l, a] = u.useState(0), c = !!(n && l);
  return ve(i.scrollbarX, () => {
    var d;
    const p = ((d = i.scrollbarX) == null ? void 0 : d.offsetHeight) || 0;
    i.onCornerHeightChange(p), a(p);
  }), ve(i.scrollbarY, () => {
    var d;
    const p = ((d = i.scrollbarY) == null ? void 0 : d.offsetWidth) || 0;
    i.onCornerWidthChange(p), s(p);
  }), c ? /* @__PURE__ */ g(
    de.div,
    {
      ...o,
      ref: t,
      style: {
        width: n,
        height: l,
        position: "absolute",
        right: i.dir === "ltr" ? 0 : void 0,
        left: i.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function Qe(e) {
  return e ? parseInt(e, 10) : 0;
}
function rn(e, t) {
  const r = e / t;
  return isNaN(r) ? 0 : r;
}
function lt(e) {
  const t = rn(e.viewport, e.content), r = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, o = (e.scrollbar.size - r) * t;
  return Math.max(o, 18);
}
function Pi(e, t, r, o = "ltr") {
  const i = lt(r), n = i / 2, s = t || n, l = i - s, a = r.scrollbar.paddingStart + s, c = r.scrollbar.size - r.scrollbar.paddingEnd - l, p = r.content - r.viewport, d = o === "ltr" ? [0, p] : [p * -1, 0];
  return nn([a, c], d)(e);
}
function ar(e, t, r = "ltr") {
  const o = lt(t), i = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, n = t.scrollbar.size - i, s = t.content - t.viewport, l = n - o, a = r === "ltr" ? [0, s] : [s * -1, 0], c = gi(e, a);
  return nn([0, s], [0, l])(c);
}
function nn(e, t) {
  return (r) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (r - e[0]);
  };
}
function on(e, t) {
  return e > 0 && e < t;
}
var Ai = (e, t = () => {
}) => {
  let r = { left: e.scrollLeft, top: e.scrollTop }, o = 0;
  return function i() {
    const n = { left: e.scrollLeft, top: e.scrollTop }, s = r.left !== n.left, l = r.top !== n.top;
    (s || l) && t(), r = n, o = window.requestAnimationFrame(i);
  }(), () => window.cancelAnimationFrame(o);
};
function at(e, t) {
  const r = Y(e), o = u.useRef(0);
  return u.useEffect(() => () => window.clearTimeout(o.current), []), u.useCallback(() => {
    window.clearTimeout(o.current), o.current = window.setTimeout(r, t);
  }, [r, t]);
}
function ve(e, t) {
  const r = Y(t);
  Ze(() => {
    let o = 0;
    if (e) {
      const i = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(r);
      });
      return i.observe(e), () => {
        window.cancelAnimationFrame(o), i.unobserve(e);
      };
    }
  }, [e, r]);
}
var Ti = Xr, Ni = Kr, Oi = Zr, Li = tn;
function $i(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var bt = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var ur;
function Di() {
  return ur || (ur = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var n = "", s = 0; s < arguments.length; s++) {
          var l = arguments[s];
          l && (n = i(n, o.call(this, l)));
        }
        return n;
      }
      function o(n) {
        if (typeof n == "string" || typeof n == "number")
          return this && this[n] || n;
        if (typeof n != "object")
          return "";
        if (Array.isArray(n))
          return r.apply(this, n);
        if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]"))
          return n.toString();
        var s = "";
        for (var l in n)
          t.call(n, l) && n[l] && (s = i(s, this && this[l] || l));
        return s;
      }
      function i(n, s) {
        return s ? n ? n + " " + s : n + s : n;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(bt)), bt.exports;
}
var Ii = Di();
const ut = /* @__PURE__ */ $i(Ii), Mi = {
  PRIMARY: "primary"
}, _t = {
  SMALL_SCREEN: "small-screen",
  LARGE_SCREEN: "large-screen",
  ALWAYS: "always"
}, ki = {
  "purpur-stepper__nav-container": "_purpur-stepper__nav-container_1o5cb_1",
  "purpur-stepper__nav": "_purpur-stepper__nav_1o5cb_1",
  "purpur-stepper": "_purpur-stepper_1o5cb_1",
  "purpur-stepper__scroll-button": "_purpur-stepper__scroll-button_1o5cb_7",
  "purpur-stepper__scroll-button--left": "_purpur-stepper__scroll-button--left_1o5cb_18",
  "purpur-stepper__scroll-button--right": "_purpur-stepper__scroll-button--right_1o5cb_21",
  "purpur-stepper__scroll-button-icon": "_purpur-stepper__scroll-button-icon_1o5cb_24",
  "purpur-stepper__hidden": "_purpur-stepper__hidden_1o5cb_27"
}, Fi = {
  "purpur-stepper-container": "_purpur-stepper-container_184lb_1",
  "purpur-stepper-container__inner--align-with-grid": "_purpur-stepper-container__inner--align-with-grid_184lb_5",
  "purpur-stepper-container--primary": "_purpur-stepper-container--primary_184lb_18",
  "purpur-stepper-container--secondary": "_purpur-stepper-container--secondary_184lb_21"
}, cr = ut.bind(Fi), Pe = "purpur-stepper-container", Wi = ({
  ["data-testid"]: e = "purpur-stepper-container",
  children: t,
  className: r,
  alignWithGrid: o,
  variant: i,
  ...n
}) => {
  const s = cr([
    r,
    Pe,
    {
      [`${Pe}--${i}`]: i
    },
    {
      [`${Pe}--align-with-grid`]: o
    }
  ]);
  return /* @__PURE__ */ g("div", { className: s, "data-testid": e, ...n, children: /* @__PURE__ */ g(
    "div",
    {
      className: cr([
        `${Pe}__inner`,
        { [`${Pe}__inner--align-with-grid`]: o }
      ]),
      children: t
    }
  ) });
}, ji = ye(
  ({ className: e, ["data-testid"]: t, children: r, ...o }, i) => /* @__PURE__ */ g("div", { ...o, "data-testid": t, ref: i, className: e, children: r })
), zi = (e) => !!e && fo(e) && !!e.props.label, Bi = {
  LG: "lg"
};
function Hi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var pr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var dr;
function qi() {
  return dr || (dr = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var n = "", s = 0; s < arguments.length; s++) {
          var l = arguments[s];
          l && (n = i(n, o(l)));
        }
        return n;
      }
      function o(n) {
        if (typeof n == "string" || typeof n == "number")
          return n;
        if (typeof n != "object")
          return "";
        if (Array.isArray(n))
          return r.apply(null, n);
        if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]"))
          return n.toString();
        var s = "";
        for (var l in n)
          t.call(n, l) && n[l] && (s = i(s, l));
        return s;
      }
      function i(n, s) {
        return s ? n ? n + " " + s : n + s : n;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(pr)), pr.exports;
}
var Ui = qi();
const fr = /* @__PURE__ */ Hi(Ui), Vi = "_rotate_1xozj_1", Yi = "_dash_1xozj_1", Ae = {
  "purpur-spinner": "_purpur-spinner_1xozj_1",
  rotate: Vi,
  "purpur-spinner--xxs": "_purpur-spinner--xxs_1xozj_4",
  "purpur-spinner--xs": "_purpur-spinner--xs_1xozj_8",
  "purpur-spinner--sm": "_purpur-spinner--sm_1xozj_12",
  "purpur-spinner--md": "_purpur-spinner--md_1xozj_16",
  "purpur-spinner--lg": "_purpur-spinner--lg_1xozj_20",
  "purpur-spinner__circle": "_purpur-spinner__circle_1xozj_24",
  dash: Yi,
  "purpur-spinner__circle--disabled": "_purpur-spinner__circle--disabled_1xozj_33",
  "purpur-spinner__circle--negative": "_purpur-spinner__circle--negative_1xozj_36"
}, Te = "purpur-spinner", Xi = {
  SM: "sm"
}, Gi = ({
  ["data-testid"]: e,
  disabled: t = !1,
  negative: r = !1,
  size: o = Xi.SM,
  ...i
}) => /* @__PURE__ */ g(
  "div",
  {
    className: fr([Ae[Te], Ae[`${Te}--${o}`]]),
    "data-testid": e,
    ...i,
    children: /* @__PURE__ */ g("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ g(
      "circle",
      {
        className: fr(Ae[`${Te}__circle`], {
          [Ae[`${Te}__circle--disabled`]]: t,
          [Ae[`${Te}__circle--negative`]]: r
        }),
        cx: "25",
        cy: "25",
        r: "20"
      }
    ) })
  }
);
function Ki(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var hr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var mr;
function Zi() {
  return mr || (mr = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var n = "", s = 0; s < arguments.length; s++) {
          var l = arguments[s];
          l && (n = i(n, o.call(this, l)));
        }
        return n;
      }
      function o(n) {
        if (typeof n == "string" || typeof n == "number")
          return this && this[n] || n;
        if (typeof n != "object")
          return "";
        if (Array.isArray(n))
          return r.apply(this, n);
        if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]"))
          return n.toString();
        var s = "";
        for (var l in n)
          t.call(n, l) && n[l] && (s = i(s, this && this[l] || l));
        return s;
      }
      function i(n, s) {
        return s ? n ? n + " " + s : n + s : n;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(hr)), hr.exports;
}
var Ji = Zi();
const Qi = /* @__PURE__ */ Ki(Ji), es = {
  "purpur-button": "_purpur-button_w455q_1",
  "purpur-button--xs": "_purpur-button--xs_w455q_33",
  "purpur-button--icon-only": "_purpur-button--icon-only_w455q_36",
  "purpur-button--sm": "_purpur-button--sm_w455q_39",
  "purpur-button--md": "_purpur-button--md_w455q_45",
  "purpur-button--lg": "_purpur-button--lg_w455q_51",
  "purpur-button--full-width": "_purpur-button--full-width_w455q_57",
  "purpur-button--primary": "_purpur-button--primary_w455q_60",
  "purpur-button--disabled": "_purpur-button--disabled_w455q_64",
  "purpur-button--primary-negative": "_purpur-button--primary-negative_w455q_70",
  "purpur-button--secondary": "_purpur-button--secondary_w455q_82",
  "purpur-button--secondary-negative": "_purpur-button--secondary-negative_w455q_93",
  "purpur-button--expressive": "_purpur-button--expressive_w455q_104",
  "purpur-button--expressive-negative": "_purpur-button--expressive-negative_w455q_114",
  "purpur-button--negative": "_purpur-button--negative_w455q_126",
  "purpur-button--destructive": "_purpur-button--destructive_w455q_133",
  "purpur-button--destructive-negative": "_purpur-button--destructive-negative_w455q_143",
  "purpur-button--tertiary-purple": "_purpur-button--tertiary-purple_w455q_153",
  "purpur-button--tertiary-purple-negative": "_purpur-button--tertiary-purple-negative_w455q_166",
  "purpur-button--text-negative": "_purpur-button--text-negative_w455q_181",
  "purpur-button--text": "_purpur-button--text_w455q_181"
}, ts = {
  TERTIARY_PURPLE: "tertiary-purple"
}, rs = Qi.bind(es), ue = "purpur-button", ns = ({
  children: e,
  className: t,
  ["data-testid"]: r,
  disabled: o = !1,
  fullWidth: i = !1,
  iconOnly: n,
  loading: s = !1,
  negative: l = !1,
  onClick: a,
  size: c = "md",
  variant: p,
  type: d = "button",
  ...h
}, f) => {
  if (n && p === "destructive")
    return null;
  const m = rs(
    [
      ue,
      `${ue}--${l ? `${p}-negative` : p}`,
      `${ue}--${c}`
    ],
    {
      [`${ue}--icon-only`]: n,
      [`${ue}--negative`]: l,
      [`${ue}--full-width`]: i,
      [`${ue}--disabled`]: o || s
    },
    t
  ), v = (b) => {
    o || s ? b.preventDefault() : a && a(b);
  }, _ = !!h["aria-disabled"] || o || s;
  return /* @__PURE__ */ H(
    "button",
    {
      className: m,
      "data-testid": r,
      type: d,
      ref: f,
      "aria-disabled": _,
      onClick: v,
      ...h,
      children: [
        s && /* @__PURE__ */ g(Gi, { size: c === Bi.LG ? "xs" : "xxs", negative: l, disabled: _ }),
        " ",
        e
      ]
    }
  );
}, sn = ye(ns);
sn.displayName = "Button";
function os(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var gr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var vr;
function is() {
  return vr || (vr = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var n = "", s = 0; s < arguments.length; s++) {
          var l = arguments[s];
          l && (n = i(n, o.call(this, l)));
        }
        return n;
      }
      function o(n) {
        if (typeof n == "string" || typeof n == "number")
          return this && this[n] || n;
        if (typeof n != "object")
          return "";
        if (Array.isArray(n))
          return r.apply(this, n);
        if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]"))
          return n.toString();
        var s = "";
        for (var l in n)
          t.call(n, l) && n[l] && (s = i(s, this && this[l] || l));
        return s;
      }
      function i(n, s) {
        return s ? n ? n + " " + s : n + s : n;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(gr)), gr.exports;
}
var ss = is();
const ls = /* @__PURE__ */ os(ss), as = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, us = ls.bind(as), br = "purpur-icon", cs = "md", ps = (e) => e.filter((t) => Object.keys(t).length >= 1).map((t) => `${t.name}="${t.value}"`).join(" "), ds = ({ content: e = "", title: t } = {}) => {
  const r = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    t ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], o = t ? `<title>${t}</title>` : "";
  return `<svg ${ps(r)}>${o}${e}</svg>`;
}, fs = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), ln = ({
  ["data-testid"]: e,
  svg: t,
  allyTitle: r,
  className: o,
  size: i = cs,
  ...n
}) => {
  const s = ds({
    content: fs(t.svg),
    title: r
  }), l = us(o, br, `${br}--${i}`);
  return /* @__PURE__ */ g(
    "span",
    {
      className: l,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: s },
      ...n
    }
  );
};
ln.displayName = "Icon";
const hs = {
  name: "info",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M11 8.18c0 .537.469.979 1.007.979.524 0 .993-.442.993-.98s-.469-.979-.993-.979c-.538 0-1.007.441-1.007.98Zm.152 1.958v6.897h1.696v-6.897h-1.696Z"/><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1.75 0a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["info"],
  category: "status"
}, an = (e) => /* @__PURE__ */ g(ln, { ...e, svg: hs });
an.displayName = "IconInfo";
function ms(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var _r = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var yr;
function gs() {
  return yr || (yr = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var n = "", s = 0; s < arguments.length; s++) {
          var l = arguments[s];
          l && (n = i(n, o(l)));
        }
        return n;
      }
      function o(n) {
        if (typeof n == "string" || typeof n == "number")
          return n;
        if (typeof n != "object")
          return "";
        if (Array.isArray(n))
          return r.apply(null, n);
        if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]"))
          return n.toString();
        var s = "";
        for (var l in n)
          t.call(n, l) && n[l] && (s = i(s, l));
        return s;
      }
      function i(n, s) {
        return s ? n ? n + " " + s : n + s : n;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(_r)), _r.exports;
}
var vs = gs();
const bs = /* @__PURE__ */ ms(vs), Ne = {
  "purpur-paragraph": "_purpur-paragraph_1rh57_1",
  "purpur-paragraph--disabled": "_purpur-paragraph--disabled_1rh57_7",
  "purpur-paragraph--hyphens": "_purpur-paragraph--hyphens_1rh57_10",
  "purpur-paragraph--negative": "_purpur-paragraph--negative_1rh57_13",
  "purpur-paragraph--paragraph-100": "_purpur-paragraph--paragraph-100_1rh57_16",
  "purpur-paragraph--paragraph-100-medium": "_purpur-paragraph--paragraph-100-medium_1rh57_22",
  "purpur-paragraph--paragraph-100-bold": "_purpur-paragraph--paragraph-100-bold_1rh57_29",
  "purpur-paragraph--paragraph-200": "_purpur-paragraph--paragraph-200_1rh57_36",
  "purpur-paragraph--preamble-100": "_purpur-paragraph--preamble-100_1rh57_42",
  "purpur-paragraph--preamble-200": "_purpur-paragraph--preamble-200_1rh57_48",
  "purpur-paragraph--additional-100": "_purpur-paragraph--additional-100_1rh57_54",
  "purpur-paragraph--additional-100-medium": "_purpur-paragraph--additional-100-medium_1rh57_60",
  "purpur-paragraph--overline-100": "_purpur-paragraph--overline-100_1rh57_67",
  "purpur-paragraph--overline-200": "_purpur-paragraph--overline-200_1rh57_75"
}, un = {
  PARAGRAPH100: "paragraph-100"
}, Oe = "purpur-paragraph", cn = ({
  ["data-testid"]: e,
  children: t,
  className: r,
  disabled: o,
  enableHyphenation: i = !1,
  negative: n = !1,
  variant: s = un.PARAGRAPH100,
  ...l
}) => {
  const a = bs([
    r,
    Ne[Oe],
    Ne[`${Oe}--${s}`],
    {
      [Ne[`${Oe}--hyphens`]]: i,
      [Ne[`${Oe}--disabled`]]: o,
      [Ne[`${Oe}--negative`]]: n
    }
  ]);
  return /* @__PURE__ */ g("p", { ...l, className: a, "data-testid": e, children: t });
};
cn.displayName = "Paragraph";
const _s = "400ms";
function J(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), r === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function wr(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function pn(...e) {
  return (t) => {
    let r = !1;
    const o = e.map((i) => {
      const n = wr(i, t);
      return !r && typeof n == "function" && (r = !0), n;
    });
    if (r)
      return () => {
        for (let i = 0; i < o.length; i++) {
          const n = o[i];
          typeof n == "function" ? n() : wr(e[i], null);
        }
      };
  };
}
function fe(...e) {
  return u.useCallback(pn(...e), e);
}
function dn(e, t = []) {
  let r = [];
  function o(n, s) {
    const l = u.createContext(s), a = r.length;
    r = [...r, s];
    const c = (d) => {
      var h;
      const { scope: f, children: m, ...v } = d, _ = ((h = f == null ? void 0 : f[e]) == null ? void 0 : h[a]) || l, b = u.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ g(_.Provider, { value: b, children: m });
    };
    c.displayName = n + "Provider";
    function p(d, h) {
      var f;
      const m = ((f = h == null ? void 0 : h[e]) == null ? void 0 : f[a]) || l, v = u.useContext(m);
      if (v) return v;
      if (s !== void 0) return s;
      throw new Error(`\`${d}\` must be used within \`${n}\``);
    }
    return [c, p];
  }
  const i = () => {
    const n = r.map((s) => u.createContext(s));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || n;
      return u.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = e, [o, ys(i, ...t)];
}
function ys(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const o = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(i) {
      const n = o.reduce((s, { useScope: l, scopeName: a }) => {
        const c = l(i)[`__scope${a}`];
        return { ...s, ...c };
      }, {});
      return u.useMemo(() => ({ [`__scope${t.scopeName}`]: n }), [n]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
var fn = u.forwardRef((e, t) => {
  const { children: r, ...o } = e, i = u.Children.toArray(r), n = i.find(ws);
  if (n) {
    const s = n.props.children, l = i.map((a) => a === n ? u.Children.count(s) > 1 ? u.Children.only(null) : u.isValidElement(s) ? s.props.children : null : a);
    return /* @__PURE__ */ g(Pt, { ...o, ref: t, children: u.isValidElement(s) ? u.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ g(Pt, { ...o, ref: t, children: r });
});
fn.displayName = "Slot";
var Pt = u.forwardRef((e, t) => {
  const { children: r, ...o } = e;
  if (u.isValidElement(r)) {
    const i = Ss(r), n = xs(o, r.props);
    return r.type !== u.Fragment && (n.ref = t ? pn(t, i) : i), u.cloneElement(r, n);
  }
  return u.Children.count(r) > 1 ? u.Children.only(null) : null;
});
Pt.displayName = "SlotClone";
var hn = ({ children: e }) => /* @__PURE__ */ g(ke, { children: e });
function ws(e) {
  return u.isValidElement(e) && e.type === hn;
}
function xs(e, t) {
  const r = { ...t };
  for (const o in t) {
    const i = e[o], n = t[o];
    /^on[A-Z]/.test(o) ? i && n ? r[o] = (...s) => {
      n(...s), i(...s);
    } : i && (r[o] = i) : o === "style" ? r[o] = { ...i, ...n } : o === "className" && (r[o] = [i, n].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function Ss(e) {
  var t, r;
  let o = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, i = o && "isReactWarning" in o && o.isReactWarning;
  return i ? e.ref : (o = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, i = o && "isReactWarning" in o && o.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var Cs = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], se = Cs.reduce((e, t) => {
  const r = u.forwardRef((o, i) => {
    const { asChild: n, ...s } = o, l = n ? fn : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(l, { ...s, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Rs(e, t) {
  e && Mr.flushSync(() => e.dispatchEvent(t));
}
function we(e) {
  const t = u.useRef(e);
  return u.useEffect(() => {
    t.current = e;
  }), u.useMemo(() => (...r) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...r);
  }, []);
}
function Es(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = we(e);
  u.useEffect(() => {
    const o = (i) => {
      i.key === "Escape" && r(i);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [r, t]);
}
var Ps = "DismissableLayer", At = "dismissableLayer.update", As = "dismissableLayer.pointerDownOutside", Ts = "dismissableLayer.focusOutside", xr, mn = u.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), gn = u.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: i,
      onFocusOutside: n,
      onInteractOutside: s,
      onDismiss: l,
      ...a
    } = e, c = u.useContext(mn), [p, d] = u.useState(null), h = (p == null ? void 0 : p.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, f] = u.useState({}), m = fe(t, (C) => d(C)), v = Array.from(c.layers), [_] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), b = v.indexOf(_), y = p ? v.indexOf(p) : -1, x = c.layersWithOutsidePointerEventsDisabled.size > 0, w = y >= b, S = Ls((C) => {
      const P = C.target, R = [...c.branches].some((E) => E.contains(P));
      !w || R || (i == null || i(C), s == null || s(C), C.defaultPrevented || l == null || l());
    }, h), A = $s((C) => {
      const P = C.target;
      [...c.branches].some((R) => R.contains(P)) || (n == null || n(C), s == null || s(C), C.defaultPrevented || l == null || l());
    }, h);
    return Es((C) => {
      y === c.layers.size - 1 && (o == null || o(C), !C.defaultPrevented && l && (C.preventDefault(), l()));
    }, h), u.useEffect(() => {
      if (p)
        return r && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (xr = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(p)), c.layers.add(p), Sr(), () => {
          r && c.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = xr);
        };
    }, [p, h, r, c]), u.useEffect(() => () => {
      p && (c.layers.delete(p), c.layersWithOutsidePointerEventsDisabled.delete(p), Sr());
    }, [p, c]), u.useEffect(() => {
      const C = () => f({});
      return document.addEventListener(At, C), () => document.removeEventListener(At, C);
    }, []), /* @__PURE__ */ g(
      se.div,
      {
        ...a,
        ref: m,
        style: {
          pointerEvents: x ? w ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: J(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: J(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: J(
          e.onPointerDownCapture,
          S.onPointerDownCapture
        )
      }
    );
  }
);
gn.displayName = Ps;
var Ns = "DismissableLayerBranch", Os = u.forwardRef((e, t) => {
  const r = u.useContext(mn), o = u.useRef(null), i = fe(t, o);
  return u.useEffect(() => {
    const n = o.current;
    if (n)
      return r.branches.add(n), () => {
        r.branches.delete(n);
      };
  }, [r.branches]), /* @__PURE__ */ g(se.div, { ...e, ref: i });
});
Os.displayName = Ns;
function Ls(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = we(e), o = u.useRef(!1), i = u.useRef(() => {
  });
  return u.useEffect(() => {
    const n = (l) => {
      if (l.target && !o.current) {
        let a = function() {
          vn(
            As,
            r,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: l };
        l.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = a, t.addEventListener("click", i.current, { once: !0 })) : a();
      } else
        t.removeEventListener("click", i.current);
      o.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", n);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", n), t.removeEventListener("click", i.current);
    };
  }, [t, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function $s(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = we(e), o = u.useRef(!1);
  return u.useEffect(() => {
    const i = (n) => {
      n.target && !o.current && vn(Ts, r, { originalEvent: n }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, r]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function Sr() {
  const e = new CustomEvent(At);
  document.dispatchEvent(e);
}
function vn(e, t, r, { discrete: o }) {
  const i = r.originalEvent.target, n = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  t && i.addEventListener(e, t, { once: !0 }), o ? Rs(i, n) : i.dispatchEvent(n);
}
var ce = globalThis != null && globalThis.document ? u.useLayoutEffect : () => {
}, Ds = u.useId || (() => {
}), Is = 0;
function Ms(e) {
  const [t, r] = u.useState(Ds());
  return ce(() => {
    r((o) => o ?? String(Is++));
  }, [e]), t ? `radix-${t}` : "";
}
const ks = ["top", "right", "bottom", "left"], X = Math.min, F = Math.max, et = Math.round, qe = Math.floor, ne = (e) => ({
  x: e,
  y: e
}), Fs = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Ws = {
  start: "end",
  end: "start"
};
function Tt(e, t, r) {
  return F(e, X(t, r));
}
function Q(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ee(e) {
  return e.split("-")[0];
}
function xe(e) {
  return e.split("-")[1];
}
function jt(e) {
  return e === "x" ? "y" : "x";
}
function zt(e) {
  return e === "y" ? "height" : "width";
}
function oe(e) {
  return ["top", "bottom"].includes(ee(e)) ? "y" : "x";
}
function Bt(e) {
  return jt(oe(e));
}
function js(e, t, r) {
  r === void 0 && (r = !1);
  const o = xe(e), i = Bt(e), n = zt(i);
  let s = i === "x" ? o === (r ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[n] > t.floating[n] && (s = tt(s)), [s, tt(s)];
}
function zs(e) {
  const t = tt(e);
  return [Nt(e), t, Nt(t)];
}
function Nt(e) {
  return e.replace(/start|end/g, (t) => Ws[t]);
}
function Bs(e, t, r) {
  const o = ["left", "right"], i = ["right", "left"], n = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? i : o : t ? o : i;
    case "left":
    case "right":
      return t ? n : s;
    default:
      return [];
  }
}
function Hs(e, t, r, o) {
  const i = xe(e);
  let n = Bs(ee(e), r === "start", o);
  return i && (n = n.map((s) => s + "-" + i), t && (n = n.concat(n.map(Nt)))), n;
}
function tt(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Fs[t]);
}
function qs(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function bn(e) {
  return typeof e != "number" ? qs(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function rt(e) {
  const {
    x: t,
    y: r,
    width: o,
    height: i
  } = e;
  return {
    width: o,
    height: i,
    top: r,
    left: t,
    right: t + o,
    bottom: r + i,
    x: t,
    y: r
  };
}
function Cr(e, t, r) {
  let {
    reference: o,
    floating: i
  } = e;
  const n = oe(t), s = Bt(t), l = zt(s), a = ee(t), c = n === "y", p = o.x + o.width / 2 - i.width / 2, d = o.y + o.height / 2 - i.height / 2, h = o[l] / 2 - i[l] / 2;
  let f;
  switch (a) {
    case "top":
      f = {
        x: p,
        y: o.y - i.height
      };
      break;
    case "bottom":
      f = {
        x: p,
        y: o.y + o.height
      };
      break;
    case "right":
      f = {
        x: o.x + o.width,
        y: d
      };
      break;
    case "left":
      f = {
        x: o.x - i.width,
        y: d
      };
      break;
    default:
      f = {
        x: o.x,
        y: o.y
      };
  }
  switch (xe(t)) {
    case "start":
      f[s] -= h * (r && c ? -1 : 1);
      break;
    case "end":
      f[s] += h * (r && c ? -1 : 1);
      break;
  }
  return f;
}
const Us = async (e, t, r) => {
  const {
    placement: o = "bottom",
    strategy: i = "absolute",
    middleware: n = [],
    platform: s
  } = r, l = n.filter(Boolean), a = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let c = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: p,
    y: d
  } = Cr(c, o, a), h = o, f = {}, m = 0;
  for (let v = 0; v < l.length; v++) {
    const {
      name: _,
      fn: b
    } = l[v], {
      x: y,
      y: x,
      data: w,
      reset: S
    } = await b({
      x: p,
      y: d,
      initialPlacement: o,
      placement: h,
      strategy: i,
      middlewareData: f,
      rects: c,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    p = y ?? p, d = x ?? d, f = {
      ...f,
      [_]: {
        ...f[_],
        ...w
      }
    }, S && m <= 50 && (m++, typeof S == "object" && (S.placement && (h = S.placement), S.rects && (c = S.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : S.rects), {
      x: p,
      y: d
    } = Cr(c, h, a)), v = -1);
  }
  return {
    x: p,
    y: d,
    placement: h,
    strategy: i,
    middlewareData: f
  };
};
async function Ie(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: o,
    y: i,
    platform: n,
    rects: s,
    elements: l,
    strategy: a
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: p = "viewport",
    elementContext: d = "floating",
    altBoundary: h = !1,
    padding: f = 0
  } = Q(t, e), m = bn(f), v = l[h ? d === "floating" ? "reference" : "floating" : d], _ = rt(await n.getClippingRect({
    element: (r = await (n.isElement == null ? void 0 : n.isElement(v))) == null || r ? v : v.contextElement || await (n.getDocumentElement == null ? void 0 : n.getDocumentElement(l.floating)),
    boundary: c,
    rootBoundary: p,
    strategy: a
  })), b = d === "floating" ? {
    x: o,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, y = await (n.getOffsetParent == null ? void 0 : n.getOffsetParent(l.floating)), x = await (n.isElement == null ? void 0 : n.isElement(y)) ? await (n.getScale == null ? void 0 : n.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, w = rt(n.convertOffsetParentRelativeRectToViewportRelativeRect ? await n.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: b,
    offsetParent: y,
    strategy: a
  }) : b);
  return {
    top: (_.top - w.top + m.top) / x.y,
    bottom: (w.bottom - _.bottom + m.bottom) / x.y,
    left: (_.left - w.left + m.left) / x.x,
    right: (w.right - _.right + m.right) / x.x
  };
}
const Vs = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: o,
      placement: i,
      rects: n,
      platform: s,
      elements: l,
      middlewareData: a
    } = t, {
      element: c,
      padding: p = 0
    } = Q(e, t) || {};
    if (c == null)
      return {};
    const d = bn(p), h = {
      x: r,
      y: o
    }, f = Bt(i), m = zt(f), v = await s.getDimensions(c), _ = f === "y", b = _ ? "top" : "left", y = _ ? "bottom" : "right", x = _ ? "clientHeight" : "clientWidth", w = n.reference[m] + n.reference[f] - h[f] - n.floating[m], S = h[f] - n.reference[f], A = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c));
    let C = A ? A[x] : 0;
    (!C || !await (s.isElement == null ? void 0 : s.isElement(A))) && (C = l.floating[x] || n.floating[m]);
    const P = w / 2 - S / 2, R = C / 2 - v[m] / 2 - 1, E = X(d[b], R), N = X(d[y], R), O = E, k = C - v[m] - N, L = C / 2 - v[m] / 2 + P, I = Tt(O, L, k), $ = !a.arrow && xe(i) != null && L !== I && n.reference[m] / 2 - (L < O ? E : N) - v[m] / 2 < 0, T = $ ? L < O ? L - O : L - k : 0;
    return {
      [f]: h[f] + T,
      data: {
        [f]: I,
        centerOffset: L - I - T,
        ...$ && {
          alignmentOffset: T
        }
      },
      reset: $
    };
  }
}), Ys = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, o;
      const {
        placement: i,
        middlewareData: n,
        rects: s,
        initialPlacement: l,
        platform: a,
        elements: c
      } = t, {
        mainAxis: p = !0,
        crossAxis: d = !0,
        fallbackPlacements: h,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: v = !0,
        ..._
      } = Q(e, t);
      if ((r = n.arrow) != null && r.alignmentOffset)
        return {};
      const b = ee(i), y = oe(l), x = ee(l) === l, w = await (a.isRTL == null ? void 0 : a.isRTL(c.floating)), S = h || (x || !v ? [tt(l)] : zs(l)), A = m !== "none";
      !h && A && S.push(...Hs(l, v, m, w));
      const C = [l, ...S], P = await Ie(t, _), R = [];
      let E = ((o = n.flip) == null ? void 0 : o.overflows) || [];
      if (p && R.push(P[b]), d) {
        const L = js(i, s, w);
        R.push(P[L[0]], P[L[1]]);
      }
      if (E = [...E, {
        placement: i,
        overflows: R
      }], !R.every((L) => L <= 0)) {
        var N, O;
        const L = (((N = n.flip) == null ? void 0 : N.index) || 0) + 1, I = C[L];
        if (I)
          return {
            data: {
              index: L,
              overflows: E
            },
            reset: {
              placement: I
            }
          };
        let $ = (O = E.filter((T) => T.overflows[0] <= 0).sort((T, M) => T.overflows[1] - M.overflows[1])[0]) == null ? void 0 : O.placement;
        if (!$)
          switch (f) {
            case "bestFit": {
              var k;
              const T = (k = E.filter((M) => {
                if (A) {
                  const D = oe(M.placement);
                  return D === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  D === "y";
                }
                return !0;
              }).map((M) => [M.placement, M.overflows.filter((D) => D > 0).reduce((D, mt) => D + mt, 0)]).sort((M, D) => M[1] - D[1])[0]) == null ? void 0 : k[0];
              T && ($ = T);
              break;
            }
            case "initialPlacement":
              $ = l;
              break;
          }
        if (i !== $)
          return {
            reset: {
              placement: $
            }
          };
      }
      return {};
    }
  };
};
function Rr(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Er(e) {
  return ks.some((t) => e[t] >= 0);
}
const Xs = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: r
      } = t, {
        strategy: o = "referenceHidden",
        ...i
      } = Q(e, t);
      switch (o) {
        case "referenceHidden": {
          const n = await Ie(t, {
            ...i,
            elementContext: "reference"
          }), s = Rr(n, r.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: Er(s)
            }
          };
        }
        case "escaped": {
          const n = await Ie(t, {
            ...i,
            altBoundary: !0
          }), s = Rr(n, r.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: Er(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Gs(e, t) {
  const {
    placement: r,
    platform: o,
    elements: i
  } = e, n = await (o.isRTL == null ? void 0 : o.isRTL(i.floating)), s = ee(r), l = xe(r), a = oe(r) === "y", c = ["left", "top"].includes(s) ? -1 : 1, p = n && a ? -1 : 1, d = Q(t, e);
  let {
    mainAxis: h,
    crossAxis: f,
    alignmentAxis: m
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return l && typeof m == "number" && (f = l === "end" ? m * -1 : m), a ? {
    x: f * p,
    y: h * c
  } : {
    x: h * c,
    y: f * p
  };
}
const Ks = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, o;
      const {
        x: i,
        y: n,
        placement: s,
        middlewareData: l
      } = t, a = await Gs(t, e);
      return s === ((r = l.offset) == null ? void 0 : r.placement) && (o = l.arrow) != null && o.alignmentOffset ? {} : {
        x: i + a.x,
        y: n + a.y,
        data: {
          ...a,
          placement: s
        }
      };
    }
  };
}, Zs = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: o,
        placement: i
      } = t, {
        mainAxis: n = !0,
        crossAxis: s = !1,
        limiter: l = {
          fn: (_) => {
            let {
              x: b,
              y
            } = _;
            return {
              x: b,
              y
            };
          }
        },
        ...a
      } = Q(e, t), c = {
        x: r,
        y: o
      }, p = await Ie(t, a), d = oe(ee(i)), h = jt(d);
      let f = c[h], m = c[d];
      if (n) {
        const _ = h === "y" ? "top" : "left", b = h === "y" ? "bottom" : "right", y = f + p[_], x = f - p[b];
        f = Tt(y, f, x);
      }
      if (s) {
        const _ = d === "y" ? "top" : "left", b = d === "y" ? "bottom" : "right", y = m + p[_], x = m - p[b];
        m = Tt(y, m, x);
      }
      const v = l.fn({
        ...t,
        [h]: f,
        [d]: m
      });
      return {
        ...v,
        data: {
          x: v.x - r,
          y: v.y - o
        }
      };
    }
  };
}, Js = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: r,
        y: o,
        placement: i,
        rects: n,
        middlewareData: s
      } = t, {
        offset: l = 0,
        mainAxis: a = !0,
        crossAxis: c = !0
      } = Q(e, t), p = {
        x: r,
        y: o
      }, d = oe(i), h = jt(d);
      let f = p[h], m = p[d];
      const v = Q(l, t), _ = typeof v == "number" ? {
        mainAxis: v,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...v
      };
      if (a) {
        const x = h === "y" ? "height" : "width", w = n.reference[h] - n.floating[x] + _.mainAxis, S = n.reference[h] + n.reference[x] - _.mainAxis;
        f < w ? f = w : f > S && (f = S);
      }
      if (c) {
        var b, y;
        const x = h === "y" ? "width" : "height", w = ["top", "left"].includes(ee(i)), S = n.reference[d] - n.floating[x] + (w && ((b = s.offset) == null ? void 0 : b[d]) || 0) + (w ? 0 : _.crossAxis), A = n.reference[d] + n.reference[x] + (w ? 0 : ((y = s.offset) == null ? void 0 : y[d]) || 0) - (w ? _.crossAxis : 0);
        m < S ? m = S : m > A && (m = A);
      }
      return {
        [h]: f,
        [d]: m
      };
    }
  };
}, Qs = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: r,
        rects: o,
        platform: i,
        elements: n
      } = t, {
        apply: s = () => {
        },
        ...l
      } = Q(e, t), a = await Ie(t, l), c = ee(r), p = xe(r), d = oe(r) === "y", {
        width: h,
        height: f
      } = o.floating;
      let m, v;
      c === "top" || c === "bottom" ? (m = c, v = p === (await (i.isRTL == null ? void 0 : i.isRTL(n.floating)) ? "start" : "end") ? "left" : "right") : (v = c, m = p === "end" ? "top" : "bottom");
      const _ = f - a.top - a.bottom, b = h - a.left - a.right, y = X(f - a[m], _), x = X(h - a[v], b), w = !t.middlewareData.shift;
      let S = y, A = x;
      if (d ? A = p || w ? X(x, b) : b : S = p || w ? X(y, _) : _, w && !p) {
        const P = F(a.left, 0), R = F(a.right, 0), E = F(a.top, 0), N = F(a.bottom, 0);
        d ? A = h - 2 * (P !== 0 || R !== 0 ? P + R : F(a.left, a.right)) : S = f - 2 * (E !== 0 || N !== 0 ? E + N : F(a.top, a.bottom));
      }
      await s({
        ...t,
        availableWidth: A,
        availableHeight: S
      });
      const C = await i.getDimensions(n.floating);
      return h !== C.width || f !== C.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Se(e) {
  return _n(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function j(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function te(e) {
  var t;
  return (t = (_n(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function _n(e) {
  return e instanceof Node || e instanceof j(e).Node;
}
function U(e) {
  return e instanceof Element || e instanceof j(e).Element;
}
function K(e) {
  return e instanceof HTMLElement || e instanceof j(e).HTMLElement;
}
function Pr(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof j(e).ShadowRoot;
}
function We(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: o,
    display: i
  } = V(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + r) && !["inline", "contents"].includes(i);
}
function el(e) {
  return ["table", "td", "th"].includes(Se(e));
}
function ct(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Ht(e) {
  const t = qt(), r = U(e) ? V(e) : e;
  return r.transform !== "none" || r.perspective !== "none" || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((o) => (r.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (r.contain || "").includes(o));
}
function tl(e) {
  let t = ie(e);
  for (; K(t) && !be(t); ) {
    if (Ht(t))
      return t;
    if (ct(t))
      return null;
    t = ie(t);
  }
  return null;
}
function qt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function be(e) {
  return ["html", "body", "#document"].includes(Se(e));
}
function V(e) {
  return j(e).getComputedStyle(e);
}
function pt(e) {
  return U(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ie(e) {
  if (Se(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Pr(e) && e.host || // Fallback.
    te(e)
  );
  return Pr(t) ? t.host : t;
}
function yn(e) {
  const t = ie(e);
  return be(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : K(t) && We(t) ? t : yn(t);
}
function Me(e, t, r) {
  var o;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const i = yn(e), n = i === ((o = e.ownerDocument) == null ? void 0 : o.body), s = j(i);
  if (n) {
    const l = Ot(s);
    return t.concat(s, s.visualViewport || [], We(i) ? i : [], l && r ? Me(l) : []);
  }
  return t.concat(i, Me(i, [], r));
}
function Ot(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function wn(e) {
  const t = V(e);
  let r = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const i = K(e), n = i ? e.offsetWidth : r, s = i ? e.offsetHeight : o, l = et(r) !== n || et(o) !== s;
  return l && (r = n, o = s), {
    width: r,
    height: o,
    $: l
  };
}
function Ut(e) {
  return U(e) ? e : e.contextElement;
}
function ge(e) {
  const t = Ut(e);
  if (!K(t))
    return ne(1);
  const r = t.getBoundingClientRect(), {
    width: o,
    height: i,
    $: n
  } = wn(t);
  let s = (n ? et(r.width) : r.width) / o, l = (n ? et(r.height) : r.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: s,
    y: l
  };
}
const rl = /* @__PURE__ */ ne(0);
function xn(e) {
  const t = j(e);
  return !qt() || !t.visualViewport ? rl : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function nl(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== j(e) ? !1 : t;
}
function pe(e, t, r, o) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const i = e.getBoundingClientRect(), n = Ut(e);
  let s = ne(1);
  t && (o ? U(o) && (s = ge(o)) : s = ge(e));
  const l = nl(n, r, o) ? xn(n) : ne(0);
  let a = (i.left + l.x) / s.x, c = (i.top + l.y) / s.y, p = i.width / s.x, d = i.height / s.y;
  if (n) {
    const h = j(n), f = o && U(o) ? j(o) : o;
    let m = h, v = Ot(m);
    for (; v && o && f !== m; ) {
      const _ = ge(v), b = v.getBoundingClientRect(), y = V(v), x = b.left + (v.clientLeft + parseFloat(y.paddingLeft)) * _.x, w = b.top + (v.clientTop + parseFloat(y.paddingTop)) * _.y;
      a *= _.x, c *= _.y, p *= _.x, d *= _.y, a += x, c += w, m = j(v), v = Ot(m);
    }
  }
  return rt({
    width: p,
    height: d,
    x: a,
    y: c
  });
}
function ol(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: o,
    strategy: i
  } = e;
  const n = i === "fixed", s = te(o), l = t ? ct(t.floating) : !1;
  if (o === s || l && n)
    return r;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = ne(1);
  const p = ne(0), d = K(o);
  if ((d || !d && !n) && ((Se(o) !== "body" || We(s)) && (a = pt(o)), K(o))) {
    const h = pe(o);
    c = ge(o), p.x = h.x + o.clientLeft, p.y = h.y + o.clientTop;
  }
  return {
    width: r.width * c.x,
    height: r.height * c.y,
    x: r.x * c.x - a.scrollLeft * c.x + p.x,
    y: r.y * c.y - a.scrollTop * c.y + p.y
  };
}
function il(e) {
  return Array.from(e.getClientRects());
}
function Sn(e) {
  return pe(te(e)).left + pt(e).scrollLeft;
}
function sl(e) {
  const t = te(e), r = pt(e), o = e.ownerDocument.body, i = F(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), n = F(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let s = -r.scrollLeft + Sn(e);
  const l = -r.scrollTop;
  return V(o).direction === "rtl" && (s += F(t.clientWidth, o.clientWidth) - i), {
    width: i,
    height: n,
    x: s,
    y: l
  };
}
function ll(e, t) {
  const r = j(e), o = te(e), i = r.visualViewport;
  let n = o.clientWidth, s = o.clientHeight, l = 0, a = 0;
  if (i) {
    n = i.width, s = i.height;
    const c = qt();
    (!c || c && t === "fixed") && (l = i.offsetLeft, a = i.offsetTop);
  }
  return {
    width: n,
    height: s,
    x: l,
    y: a
  };
}
function al(e, t) {
  const r = pe(e, !0, t === "fixed"), o = r.top + e.clientTop, i = r.left + e.clientLeft, n = K(e) ? ge(e) : ne(1), s = e.clientWidth * n.x, l = e.clientHeight * n.y, a = i * n.x, c = o * n.y;
  return {
    width: s,
    height: l,
    x: a,
    y: c
  };
}
function Ar(e, t, r) {
  let o;
  if (t === "viewport")
    o = ll(e, r);
  else if (t === "document")
    o = sl(te(e));
  else if (U(t))
    o = al(t, r);
  else {
    const i = xn(e);
    o = {
      ...t,
      x: t.x - i.x,
      y: t.y - i.y
    };
  }
  return rt(o);
}
function Cn(e, t) {
  const r = ie(e);
  return r === t || !U(r) || be(r) ? !1 : V(r).position === "fixed" || Cn(r, t);
}
function ul(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let o = Me(e, [], !1).filter((l) => U(l) && Se(l) !== "body"), i = null;
  const n = V(e).position === "fixed";
  let s = n ? ie(e) : e;
  for (; U(s) && !be(s); ) {
    const l = V(s), a = Ht(s);
    !a && l.position === "fixed" && (i = null), (n ? !a && !i : !a && l.position === "static" && i && ["absolute", "fixed"].includes(i.position) || We(s) && !a && Cn(e, s)) ? o = o.filter((c) => c !== s) : i = l, s = ie(s);
  }
  return t.set(e, o), o;
}
function cl(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: o,
    strategy: i
  } = e;
  const n = [...r === "clippingAncestors" ? ct(t) ? [] : ul(t, this._c) : [].concat(r), o], s = n[0], l = n.reduce((a, c) => {
    const p = Ar(t, c, i);
    return a.top = F(p.top, a.top), a.right = X(p.right, a.right), a.bottom = X(p.bottom, a.bottom), a.left = F(p.left, a.left), a;
  }, Ar(t, s, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function pl(e) {
  const {
    width: t,
    height: r
  } = wn(e);
  return {
    width: t,
    height: r
  };
}
function dl(e, t, r) {
  const o = K(t), i = te(t), n = r === "fixed", s = pe(e, !0, n, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const a = ne(0);
  if (o || !o && !n)
    if ((Se(t) !== "body" || We(i)) && (l = pt(t)), o) {
      const d = pe(t, !0, n, t);
      a.x = d.x + t.clientLeft, a.y = d.y + t.clientTop;
    } else i && (a.x = Sn(i));
  const c = s.left + l.scrollLeft - a.x, p = s.top + l.scrollTop - a.y;
  return {
    x: c,
    y: p,
    width: s.width,
    height: s.height
  };
}
function yt(e) {
  return V(e).position === "static";
}
function Tr(e, t) {
  return !K(e) || V(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function Rn(e, t) {
  const r = j(e);
  if (ct(e))
    return r;
  if (!K(e)) {
    let i = ie(e);
    for (; i && !be(i); ) {
      if (U(i) && !yt(i))
        return i;
      i = ie(i);
    }
    return r;
  }
  let o = Tr(e, t);
  for (; o && el(o) && yt(o); )
    o = Tr(o, t);
  return o && be(o) && yt(o) && !Ht(o) ? r : o || tl(e) || r;
}
const fl = async function(e) {
  const t = this.getOffsetParent || Rn, r = this.getDimensions, o = await r(e.floating);
  return {
    reference: dl(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function hl(e) {
  return V(e).direction === "rtl";
}
const ml = {
  convertOffsetParentRelativeRectToViewportRelativeRect: ol,
  getDocumentElement: te,
  getClippingRect: cl,
  getOffsetParent: Rn,
  getElementRects: fl,
  getClientRects: il,
  getDimensions: pl,
  getScale: ge,
  isElement: U,
  isRTL: hl
};
function gl(e, t) {
  let r = null, o;
  const i = te(e);
  function n() {
    var l;
    clearTimeout(o), (l = r) == null || l.disconnect(), r = null;
  }
  function s(l, a) {
    l === void 0 && (l = !1), a === void 0 && (a = 1), n();
    const {
      left: c,
      top: p,
      width: d,
      height: h
    } = e.getBoundingClientRect();
    if (l || t(), !d || !h)
      return;
    const f = qe(p), m = qe(i.clientWidth - (c + d)), v = qe(i.clientHeight - (p + h)), _ = qe(c), b = {
      rootMargin: -f + "px " + -m + "px " + -v + "px " + -_ + "px",
      threshold: F(0, X(1, a)) || 1
    };
    let y = !0;
    function x(w) {
      const S = w[0].intersectionRatio;
      if (S !== a) {
        if (!y)
          return s();
        S ? s(!1, S) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      y = !1;
    }
    try {
      r = new IntersectionObserver(x, {
        ...b,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(x, b);
    }
    r.observe(e);
  }
  return s(!0), n;
}
function vl(e, t, r, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: n = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: a = !1
  } = o, c = Ut(e), p = i || n ? [...c ? Me(c) : [], ...Me(t)] : [];
  p.forEach((b) => {
    i && b.addEventListener("scroll", r, {
      passive: !0
    }), n && b.addEventListener("resize", r);
  });
  const d = c && l ? gl(c, r) : null;
  let h = -1, f = null;
  s && (f = new ResizeObserver((b) => {
    let [y] = b;
    y && y.target === c && f && (f.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var x;
      (x = f) == null || x.observe(t);
    })), r();
  }), c && !a && f.observe(c), f.observe(t));
  let m, v = a ? pe(e) : null;
  a && _();
  function _() {
    const b = pe(e);
    v && (b.x !== v.x || b.y !== v.y || b.width !== v.width || b.height !== v.height) && r(), v = b, m = requestAnimationFrame(_);
  }
  return r(), () => {
    var b;
    p.forEach((y) => {
      i && y.removeEventListener("scroll", r), n && y.removeEventListener("resize", r);
    }), d == null || d(), (b = f) == null || b.disconnect(), f = null, a && cancelAnimationFrame(m);
  };
}
const bl = Ks, _l = Zs, yl = Ys, wl = Qs, xl = Xs, Nr = Vs, Sl = Js, Cl = (e, t, r) => {
  const o = /* @__PURE__ */ new Map(), i = {
    platform: ml,
    ...r
  }, n = {
    ...i.platform,
    _c: o
  };
  return Us(e, t, {
    ...i,
    platform: n
  });
};
var Xe = typeof document < "u" ? ho : It;
function nt(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, o, i;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r !== t.length) return !1;
      for (o = r; o-- !== 0; )
        if (!nt(e[o], t[o]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), r = i.length, r !== Object.keys(t).length)
      return !1;
    for (o = r; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, i[o]))
        return !1;
    for (o = r; o-- !== 0; ) {
      const n = i[o];
      if (!(n === "_owner" && e.$$typeof) && !nt(e[n], t[n]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function En(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Or(e, t) {
  const r = En(e);
  return Math.round(t * r) / r;
}
function Lr(e) {
  const t = u.useRef(e);
  return Xe(() => {
    t.current = e;
  }), t;
}
function Rl(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: o = [],
    platform: i,
    elements: {
      reference: n,
      floating: s
    } = {},
    transform: l = !0,
    whileElementsMounted: a,
    open: c
  } = e, [p, d] = u.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, f] = u.useState(o);
  nt(h, o) || f(o);
  const [m, v] = u.useState(null), [_, b] = u.useState(null), y = u.useCallback((T) => {
    T !== A.current && (A.current = T, v(T));
  }, []), x = u.useCallback((T) => {
    T !== C.current && (C.current = T, b(T));
  }, []), w = n || m, S = s || _, A = u.useRef(null), C = u.useRef(null), P = u.useRef(p), R = a != null, E = Lr(a), N = Lr(i), O = u.useCallback(() => {
    if (!A.current || !C.current)
      return;
    const T = {
      placement: t,
      strategy: r,
      middleware: h
    };
    N.current && (T.platform = N.current), Cl(A.current, C.current, T).then((M) => {
      const D = {
        ...M,
        isPositioned: !0
      };
      k.current && !nt(P.current, D) && (P.current = D, Mr.flushSync(() => {
        d(D);
      }));
    });
  }, [h, t, r, N]);
  Xe(() => {
    c === !1 && P.current.isPositioned && (P.current.isPositioned = !1, d((T) => ({
      ...T,
      isPositioned: !1
    })));
  }, [c]);
  const k = u.useRef(!1);
  Xe(() => (k.current = !0, () => {
    k.current = !1;
  }), []), Xe(() => {
    if (w && (A.current = w), S && (C.current = S), w && S) {
      if (E.current)
        return E.current(w, S, O);
      O();
    }
  }, [w, S, O, E, R]);
  const L = u.useMemo(() => ({
    reference: A,
    floating: C,
    setReference: y,
    setFloating: x
  }), [y, x]), I = u.useMemo(() => ({
    reference: w,
    floating: S
  }), [w, S]), $ = u.useMemo(() => {
    const T = {
      position: r,
      left: 0,
      top: 0
    };
    if (!I.floating)
      return T;
    const M = Or(I.floating, p.x), D = Or(I.floating, p.y);
    return l ? {
      ...T,
      transform: "translate(" + M + "px, " + D + "px)",
      ...En(I.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: M,
      top: D
    };
  }, [r, l, I.floating, p.x, p.y]);
  return u.useMemo(() => ({
    ...p,
    update: O,
    refs: L,
    elements: I,
    floatingStyles: $
  }), [p, O, L, I, $]);
}
const El = (e) => {
  function t(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(r) {
      const {
        element: o,
        padding: i
      } = typeof e == "function" ? e(r) : e;
      return o && t(o) ? o.current != null ? Nr({
        element: o.current,
        padding: i
      }).fn(r) : {} : o ? Nr({
        element: o,
        padding: i
      }).fn(r) : {};
    }
  };
}, Pl = (e, t) => ({
  ...bl(e),
  options: [e, t]
}), Al = (e, t) => ({
  ..._l(e),
  options: [e, t]
}), Tl = (e, t) => ({
  ...Sl(e),
  options: [e, t]
}), Nl = (e, t) => ({
  ...yl(e),
  options: [e, t]
}), Ol = (e, t) => ({
  ...wl(e),
  options: [e, t]
}), Ll = (e, t) => ({
  ...xl(e),
  options: [e, t]
}), $l = (e, t) => ({
  ...El(e),
  options: [e, t]
});
var Dl = "Arrow", Pn = u.forwardRef((e, t) => {
  const { children: r, width: o = 10, height: i = 5, ...n } = e;
  return /* @__PURE__ */ g(
    se.svg,
    {
      ...n,
      ref: t,
      width: o,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? r : /* @__PURE__ */ g("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Pn.displayName = Dl;
var Il = Pn;
function Ml(e) {
  const [t, r] = u.useState(void 0);
  return ce(() => {
    if (e) {
      r({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const n = i[0];
        let s, l;
        if ("borderBoxSize" in n) {
          const a = n.borderBoxSize, c = Array.isArray(a) ? a[0] : a;
          s = c.inlineSize, l = c.blockSize;
        } else
          s = e.offsetWidth, l = e.offsetHeight;
        r({ width: s, height: l });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      r(void 0);
  }, [e]), t;
}
var Vt = "Popper", [An, Tn] = dn(Vt), [kl, Nn] = An(Vt), On = (e) => {
  const { __scopePopper: t, children: r } = e, [o, i] = u.useState(null);
  return /* @__PURE__ */ g(kl, { scope: t, anchor: o, onAnchorChange: i, children: r });
};
On.displayName = Vt;
var Ln = "PopperAnchor", $n = u.forwardRef(
  (e, t) => {
    const { __scopePopper: r, virtualRef: o, ...i } = e, n = Nn(Ln, r), s = u.useRef(null), l = fe(t, s);
    return u.useEffect(() => {
      n.onAnchorChange((o == null ? void 0 : o.current) || s.current);
    }), o ? null : /* @__PURE__ */ g(se.div, { ...i, ref: l });
  }
);
$n.displayName = Ln;
var Yt = "PopperContent", [Fl, Wl] = An(Yt), Dn = u.forwardRef(
  (e, t) => {
    var r, o, i, n, s, l;
    const {
      __scopePopper: a,
      side: c = "bottom",
      sideOffset: p = 0,
      align: d = "center",
      alignOffset: h = 0,
      arrowPadding: f = 0,
      avoidCollisions: m = !0,
      collisionBoundary: v = [],
      collisionPadding: _ = 0,
      sticky: b = "partial",
      hideWhenDetached: y = !1,
      updatePositionStrategy: x = "optimized",
      onPlaced: w,
      ...S
    } = e, A = Nn(Yt, a), [C, P] = u.useState(null), R = fe(t, (Ce) => P(Ce)), [E, N] = u.useState(null), O = Ml(E), k = (O == null ? void 0 : O.width) ?? 0, L = (O == null ? void 0 : O.height) ?? 0, I = c + (d !== "center" ? "-" + d : ""), $ = typeof _ == "number" ? _ : { top: 0, right: 0, bottom: 0, left: 0, ..._ }, T = Array.isArray(v) ? v : [v], M = T.length > 0, D = {
      padding: $,
      boundary: T.filter(zl),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: M
    }, { refs: mt, floatingStyles: Zt, placement: eo, isPositioned: ze, middlewareData: he } = Rl({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: I,
      whileElementsMounted: (...Ce) => vl(...Ce, {
        animationFrame: x === "always"
      }),
      elements: {
        reference: A.anchor
      },
      middleware: [
        Pl({ mainAxis: p + L, alignmentAxis: h }),
        m && Al({
          mainAxis: !0,
          crossAxis: !1,
          limiter: b === "partial" ? Tl() : void 0,
          ...D
        }),
        m && Nl({ ...D }),
        Ol({
          ...D,
          apply: ({ elements: Ce, rects: lo, availableWidth: ao, availableHeight: uo }) => {
            const { width: co, height: po } = lo.reference, Be = Ce.floating.style;
            Be.setProperty("--radix-popper-available-width", `${ao}px`), Be.setProperty("--radix-popper-available-height", `${uo}px`), Be.setProperty("--radix-popper-anchor-width", `${co}px`), Be.setProperty("--radix-popper-anchor-height", `${po}px`);
          }
        }),
        E && $l({ element: E, padding: f }),
        Bl({ arrowWidth: k, arrowHeight: L }),
        y && Ll({ strategy: "referenceHidden", ...D })
      ]
    }), [Jt, to] = kn(eo), gt = we(w);
    ce(() => {
      ze && (gt == null || gt());
    }, [ze, gt]);
    const ro = (r = he.arrow) == null ? void 0 : r.x, no = (o = he.arrow) == null ? void 0 : o.y, oo = ((i = he.arrow) == null ? void 0 : i.centerOffset) !== 0, [io, so] = u.useState();
    return ce(() => {
      C && so(window.getComputedStyle(C).zIndex);
    }, [C]), /* @__PURE__ */ g(
      "div",
      {
        ref: mt.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...Zt,
          transform: ze ? Zt.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: io,
          "--radix-popper-transform-origin": [
            (n = he.transformOrigin) == null ? void 0 : n.x,
            (s = he.transformOrigin) == null ? void 0 : s.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((l = he.hide) == null ? void 0 : l.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ g(
          Fl,
          {
            scope: a,
            placedSide: Jt,
            onArrowChange: N,
            arrowX: ro,
            arrowY: no,
            shouldHideArrow: oo,
            children: /* @__PURE__ */ g(
              se.div,
              {
                "data-side": Jt,
                "data-align": to,
                ...S,
                ref: R,
                style: {
                  ...S.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: ze ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Dn.displayName = Yt;
var In = "PopperArrow", jl = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Mn = u.forwardRef(function(e, t) {
  const { __scopePopper: r, ...o } = e, i = Wl(In, r), n = jl[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ g(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [n]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ g(
          Il,
          {
            ...o,
            ref: t,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Mn.displayName = In;
function zl(e) {
  return e !== null;
}
var Bl = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var r, o, i;
    const { placement: n, rects: s, middlewareData: l } = t, a = ((r = l.arrow) == null ? void 0 : r.centerOffset) !== 0, c = a ? 0 : e.arrowWidth, p = a ? 0 : e.arrowHeight, [d, h] = kn(n), f = { start: "0%", center: "50%", end: "100%" }[h], m = (((o = l.arrow) == null ? void 0 : o.x) ?? 0) + c / 2, v = (((i = l.arrow) == null ? void 0 : i.y) ?? 0) + p / 2;
    let _ = "", b = "";
    return d === "bottom" ? (_ = a ? f : `${m}px`, b = `${-p}px`) : d === "top" ? (_ = a ? f : `${m}px`, b = `${s.floating.height + p}px`) : d === "right" ? (_ = `${-p}px`, b = a ? f : `${v}px`) : d === "left" && (_ = `${s.floating.width + p}px`, b = a ? f : `${v}px`), { data: { x: _, y: b } };
  }
});
function kn(e) {
  const [t, r = "center"] = e.split("-");
  return [t, r];
}
var Hl = On, ql = $n, Ul = Dn, Vl = Mn, Yl = "Portal", Fn = u.forwardRef((e, t) => {
  var r;
  const { container: o, ...i } = e, [n, s] = u.useState(!1);
  ce(() => s(!0), []);
  const l = o || n && ((r = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : r.body);
  return l ? mo.createPortal(/* @__PURE__ */ g(se.div, { ...i, ref: t }), l) : null;
});
Fn.displayName = Yl;
function Xl(e, t) {
  return u.useReducer((r, o) => t[r][o] ?? r, e);
}
var Xt = (e) => {
  const { present: t, children: r } = e, o = Gl(t), i = typeof r == "function" ? r({ present: o.isPresent }) : u.Children.only(r), n = fe(o.ref, Kl(i));
  return typeof r == "function" || o.isPresent ? u.cloneElement(i, { ref: n }) : null;
};
Xt.displayName = "Presence";
function Gl(e) {
  const [t, r] = u.useState(), o = u.useRef({}), i = u.useRef(e), n = u.useRef("none"), s = e ? "mounted" : "unmounted", [l, a] = Xl(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return u.useEffect(() => {
    const c = Ue(o.current);
    n.current = l === "mounted" ? c : "none";
  }, [l]), ce(() => {
    const c = o.current, p = i.current;
    if (p !== e) {
      const d = n.current, h = Ue(c);
      e ? a("MOUNT") : h === "none" || (c == null ? void 0 : c.display) === "none" ? a("UNMOUNT") : a(p && d !== h ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, a]), ce(() => {
    if (t) {
      let c;
      const p = t.ownerDocument.defaultView ?? window, d = (f) => {
        const m = Ue(o.current).includes(f.animationName);
        if (f.target === t && m && (a("ANIMATION_END"), !i.current)) {
          const v = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = p.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = v);
          });
        }
      }, h = (f) => {
        f.target === t && (n.current = Ue(o.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        p.clearTimeout(c), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      a("ANIMATION_END");
  }, [t, a]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: u.useCallback((c) => {
      c && (o.current = getComputedStyle(c)), r(c);
    }, [])
  };
}
function Ue(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Kl(e) {
  var t, r;
  let o = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, i = o && "isReactWarning" in o && o.isReactWarning;
  return i ? e.ref : (o = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, i = o && "isReactWarning" in o && o.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
function Zl({
  prop: e,
  defaultProp: t,
  onChange: r = () => {
  }
}) {
  const [o, i] = Jl({ defaultProp: t, onChange: r }), n = e !== void 0, s = n ? e : o, l = we(r), a = u.useCallback(
    (c) => {
      if (n) {
        const p = typeof c == "function" ? c(e) : c;
        p !== e && l(p);
      } else
        i(c);
    },
    [n, e, i, l]
  );
  return [s, a];
}
function Jl({
  defaultProp: e,
  onChange: t
}) {
  const r = u.useState(e), [o] = r, i = u.useRef(o), n = we(t);
  return u.useEffect(() => {
    i.current !== o && (n(o), i.current = o);
  }, [o, i, n]), r;
}
var Ql = "VisuallyHidden", Wn = u.forwardRef(
  (e, t) => /* @__PURE__ */ g(
    se.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
Wn.displayName = Ql;
var ea = Wn, [dt, eu] = dn("Tooltip", [
  Tn
]), ft = Tn(), jn = "TooltipProvider", ta = 700, Lt = "tooltip.open", [ra, Gt] = dt(jn), zn = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: r = ta,
    skipDelayDuration: o = 300,
    disableHoverableContent: i = !1,
    children: n
  } = e, [s, l] = u.useState(!0), a = u.useRef(!1), c = u.useRef(0);
  return u.useEffect(() => {
    const p = c.current;
    return () => window.clearTimeout(p);
  }, []), /* @__PURE__ */ g(
    ra,
    {
      scope: t,
      isOpenDelayed: s,
      delayDuration: r,
      onOpen: u.useCallback(() => {
        window.clearTimeout(c.current), l(!1);
      }, []),
      onClose: u.useCallback(() => {
        window.clearTimeout(c.current), c.current = window.setTimeout(
          () => l(!0),
          o
        );
      }, [o]),
      isPointerInTransitRef: a,
      onPointerInTransitChange: u.useCallback((p) => {
        a.current = p;
      }, []),
      disableHoverableContent: i,
      children: n
    }
  );
};
zn.displayName = jn;
var ht = "Tooltip", [na, je] = dt(ht), Bn = (e) => {
  const {
    __scopeTooltip: t,
    children: r,
    open: o,
    defaultOpen: i = !1,
    onOpenChange: n,
    disableHoverableContent: s,
    delayDuration: l
  } = e, a = Gt(ht, e.__scopeTooltip), c = ft(t), [p, d] = u.useState(null), h = Ms(), f = u.useRef(0), m = s ?? a.disableHoverableContent, v = l ?? a.delayDuration, _ = u.useRef(!1), [b = !1, y] = Zl({
    prop: o,
    defaultProp: i,
    onChange: (C) => {
      C ? (a.onOpen(), document.dispatchEvent(new CustomEvent(Lt))) : a.onClose(), n == null || n(C);
    }
  }), x = u.useMemo(() => b ? _.current ? "delayed-open" : "instant-open" : "closed", [b]), w = u.useCallback(() => {
    window.clearTimeout(f.current), f.current = 0, _.current = !1, y(!0);
  }, [y]), S = u.useCallback(() => {
    window.clearTimeout(f.current), f.current = 0, y(!1);
  }, [y]), A = u.useCallback(() => {
    window.clearTimeout(f.current), f.current = window.setTimeout(() => {
      _.current = !0, y(!0), f.current = 0;
    }, v);
  }, [v, y]);
  return u.useEffect(() => () => {
    f.current && (window.clearTimeout(f.current), f.current = 0);
  }, []), /* @__PURE__ */ g(Hl, { ...c, children: /* @__PURE__ */ g(
    na,
    {
      scope: t,
      contentId: h,
      open: b,
      stateAttribute: x,
      trigger: p,
      onTriggerChange: d,
      onTriggerEnter: u.useCallback(() => {
        a.isOpenDelayed ? A() : w();
      }, [a.isOpenDelayed, A, w]),
      onTriggerLeave: u.useCallback(() => {
        m ? S() : (window.clearTimeout(f.current), f.current = 0);
      }, [S, m]),
      onOpen: w,
      onClose: S,
      disableHoverableContent: m,
      children: r
    }
  ) });
};
Bn.displayName = ht;
var $t = "TooltipTrigger", Hn = u.forwardRef(
  (e, t) => {
    const { __scopeTooltip: r, ...o } = e, i = je($t, r), n = Gt($t, r), s = ft(r), l = u.useRef(null), a = fe(t, l, i.onTriggerChange), c = u.useRef(!1), p = u.useRef(!1), d = u.useCallback(() => c.current = !1, []);
    return u.useEffect(() => () => document.removeEventListener("pointerup", d), [d]), /* @__PURE__ */ g(ql, { asChild: !0, ...s, children: /* @__PURE__ */ g(
      se.button,
      {
        "aria-describedby": i.open ? i.contentId : void 0,
        "data-state": i.stateAttribute,
        ...o,
        ref: a,
        onPointerMove: J(e.onPointerMove, (h) => {
          h.pointerType !== "touch" && !p.current && !n.isPointerInTransitRef.current && (i.onTriggerEnter(), p.current = !0);
        }),
        onPointerLeave: J(e.onPointerLeave, () => {
          i.onTriggerLeave(), p.current = !1;
        }),
        onPointerDown: J(e.onPointerDown, () => {
          c.current = !0, document.addEventListener("pointerup", d, { once: !0 });
        }),
        onFocus: J(e.onFocus, () => {
          c.current || i.onOpen();
        }),
        onBlur: J(e.onBlur, i.onClose),
        onClick: J(e.onClick, i.onClose)
      }
    ) });
  }
);
Hn.displayName = $t;
var Kt = "TooltipPortal", [oa, ia] = dt(Kt, {
  forceMount: void 0
}), qn = (e) => {
  const { __scopeTooltip: t, forceMount: r, children: o, container: i } = e, n = je(Kt, t);
  return /* @__PURE__ */ g(oa, { scope: t, forceMount: r, children: /* @__PURE__ */ g(Xt, { present: r || n.open, children: /* @__PURE__ */ g(Fn, { asChild: !0, container: i, children: o }) }) });
};
qn.displayName = Kt;
var _e = "TooltipContent", Un = u.forwardRef(
  (e, t) => {
    const r = ia(_e, e.__scopeTooltip), { forceMount: o = r.forceMount, side: i = "top", ...n } = e, s = je(_e, e.__scopeTooltip);
    return /* @__PURE__ */ g(Xt, { present: o || s.open, children: s.disableHoverableContent ? /* @__PURE__ */ g(Vn, { side: i, ...n, ref: t }) : /* @__PURE__ */ g(sa, { side: i, ...n, ref: t }) });
  }
), sa = u.forwardRef((e, t) => {
  const r = je(_e, e.__scopeTooltip), o = Gt(_e, e.__scopeTooltip), i = u.useRef(null), n = fe(t, i), [s, l] = u.useState(null), { trigger: a, onClose: c } = r, p = i.current, { onPointerInTransitChange: d } = o, h = u.useCallback(() => {
    l(null), d(!1);
  }, [d]), f = u.useCallback(
    (m, v) => {
      const _ = m.currentTarget, b = { x: m.clientX, y: m.clientY }, y = ua(b, _.getBoundingClientRect()), x = ca(b, y), w = pa(v.getBoundingClientRect()), S = fa([...x, ...w]);
      l(S), d(!0);
    },
    [d]
  );
  return u.useEffect(() => () => h(), [h]), u.useEffect(() => {
    if (a && p) {
      const m = (_) => f(_, p), v = (_) => f(_, a);
      return a.addEventListener("pointerleave", m), p.addEventListener("pointerleave", v), () => {
        a.removeEventListener("pointerleave", m), p.removeEventListener("pointerleave", v);
      };
    }
  }, [a, p, f, h]), u.useEffect(() => {
    if (s) {
      const m = (v) => {
        const _ = v.target, b = { x: v.clientX, y: v.clientY }, y = (a == null ? void 0 : a.contains(_)) || (p == null ? void 0 : p.contains(_)), x = !da(b, s);
        y ? h() : x && (h(), c());
      };
      return document.addEventListener("pointermove", m), () => document.removeEventListener("pointermove", m);
    }
  }, [a, p, s, c, h]), /* @__PURE__ */ g(Vn, { ...e, ref: n });
}), [la, aa] = dt(ht, { isInside: !1 }), Vn = u.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: r,
      children: o,
      "aria-label": i,
      onEscapeKeyDown: n,
      onPointerDownOutside: s,
      ...l
    } = e, a = je(_e, r), c = ft(r), { onClose: p } = a;
    return u.useEffect(() => (document.addEventListener(Lt, p), () => document.removeEventListener(Lt, p)), [p]), u.useEffect(() => {
      if (a.trigger) {
        const d = (h) => {
          const f = h.target;
          f != null && f.contains(a.trigger) && p();
        };
        return window.addEventListener("scroll", d, { capture: !0 }), () => window.removeEventListener("scroll", d, { capture: !0 });
      }
    }, [a.trigger, p]), /* @__PURE__ */ g(
      gn,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: n,
        onPointerDownOutside: s,
        onFocusOutside: (d) => d.preventDefault(),
        onDismiss: p,
        children: /* @__PURE__ */ H(
          Ul,
          {
            "data-state": a.stateAttribute,
            ...c,
            ...l,
            ref: t,
            style: {
              ...l.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ g(hn, { children: o }),
              /* @__PURE__ */ g(la, { scope: r, isInside: !0, children: /* @__PURE__ */ g(ea, { id: a.contentId, role: "tooltip", children: i || o }) })
            ]
          }
        )
      }
    );
  }
);
Un.displayName = _e;
var Yn = "TooltipArrow", Xn = u.forwardRef(
  (e, t) => {
    const { __scopeTooltip: r, ...o } = e, i = ft(r);
    return aa(
      Yn,
      r
    ).isInside ? null : /* @__PURE__ */ g(Vl, { ...i, ...o, ref: t });
  }
);
Xn.displayName = Yn;
function ua(e, t) {
  const r = Math.abs(t.top - e.y), o = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), n = Math.abs(t.left - e.x);
  switch (Math.min(r, o, i, n)) {
    case n:
      return "left";
    case i:
      return "right";
    case r:
      return "top";
    case o:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function ca(e, t, r = 5) {
  const o = [];
  switch (t) {
    case "top":
      o.push(
        { x: e.x - r, y: e.y + r },
        { x: e.x + r, y: e.y + r }
      );
      break;
    case "bottom":
      o.push(
        { x: e.x - r, y: e.y - r },
        { x: e.x + r, y: e.y - r }
      );
      break;
    case "left":
      o.push(
        { x: e.x + r, y: e.y - r },
        { x: e.x + r, y: e.y + r }
      );
      break;
    case "right":
      o.push(
        { x: e.x - r, y: e.y - r },
        { x: e.x - r, y: e.y + r }
      );
      break;
  }
  return o;
}
function pa(e) {
  const { top: t, right: r, bottom: o, left: i } = e;
  return [
    { x: i, y: t },
    { x: r, y: t },
    { x: r, y: o },
    { x: i, y: o }
  ];
}
function da(e, t) {
  const { x: r, y: o } = e;
  let i = !1;
  for (let n = 0, s = t.length - 1; n < t.length; s = n++) {
    const l = t[n].x, a = t[n].y, c = t[s].x, p = t[s].y;
    a > o != p > o && r < (c - l) * (o - a) / (p - a) + l && (i = !i);
  }
  return i;
}
function fa(e) {
  const t = e.slice();
  return t.sort((r, o) => r.x < o.x ? -1 : r.x > o.x ? 1 : r.y < o.y ? -1 : r.y > o.y ? 1 : 0), ha(t);
}
function ha(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let o = 0; o < e.length; o++) {
    const i = e[o];
    for (; t.length >= 2; ) {
      const n = t[t.length - 1], s = t[t.length - 2];
      if ((n.x - s.x) * (i.y - s.y) >= (n.y - s.y) * (i.x - s.x)) t.pop();
      else break;
    }
    t.push(i);
  }
  t.pop();
  const r = [];
  for (let o = e.length - 1; o >= 0; o--) {
    const i = e[o];
    for (; r.length >= 2; ) {
      const n = r[r.length - 1], s = r[r.length - 2];
      if ((n.x - s.x) * (i.y - s.y) >= (n.y - s.y) * (i.x - s.x)) r.pop();
      else break;
    }
    r.push(i);
  }
  return r.pop(), t.length === 1 && r.length === 1 && t[0].x === r[0].x && t[0].y === r[0].y ? t : t.concat(r);
}
var ma = zn, ga = Bn, va = Hn, ba = qn, _a = Un, ya = Xn;
function wa(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $r = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Dr;
function xa() {
  return Dr || (Dr = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var n = "", s = 0; s < arguments.length; s++) {
          var l = arguments[s];
          l && (n = i(n, o.call(this, l)));
        }
        return n;
      }
      function o(n) {
        if (typeof n == "string" || typeof n == "number")
          return this && this[n] || n;
        if (typeof n != "object")
          return "";
        if (Array.isArray(n))
          return r.apply(this, n);
        if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]"))
          return n.toString();
        var s = "";
        for (var l in n)
          t.call(n, l) && n[l] && (s = i(s, this && this[l] || l));
        return s;
      }
      function i(n, s) {
        return s ? n ? n + " " + s : n + s : n;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }($r)), $r.exports;
}
var Sa = xa();
const Ca = /* @__PURE__ */ wa(Sa), Ra = "_slideDownAndFade_fkagk_1", Ea = "_slideLeftAndFade_fkagk_1", Pa = "_slideUpAndFade_fkagk_1", Aa = "_slideRightAndFade_fkagk_1", Ta = {
  "purpur-tooltip": "_purpur-tooltip_fkagk_1",
  "purpur-tooltip__content": "_purpur-tooltip__content_fkagk_4",
  "purpur-tooltip__content--primary": "_purpur-tooltip__content--primary_fkagk_14",
  "purpur-tooltip__content--primary-negative": "_purpur-tooltip__content--primary-negative_fkagk_17",
  slideDownAndFade: Ra,
  slideLeftAndFade: Ea,
  slideUpAndFade: Pa,
  slideRightAndFade: Aa,
  "purpur-tooltip__arrow--primary": "_purpur-tooltip__arrow--primary_fkagk_32",
  "purpur-tooltip__arrow--primary-negative": "_purpur-tooltip__arrow--primary-negative_fkagk_35"
}, wt = Ca.bind(Ta), Na = {
  TOP: "top"
}, Oa = {
  CENTER: "center"
}, me = "purpur-tooltip", Gn = ye(
  ({
    ["data-testid"]: e,
    buttonSize: t = "md",
    children: r,
    className: o,
    contentClassName: i,
    negative: n = !1,
    position: s = Na.TOP,
    align: l = Oa.CENTER,
    triggerAriaLabel: a,
    triggerElement: c,
    ...p
  }, d) => {
    const [h, f] = St(!1), m = wt([
      o,
      me,
      `${me}--primary${n ? "-negative" : ""}`
    ]), v = /* @__PURE__ */ g(
      sn,
      {
        ref: d,
        "aria-label": a,
        variant: ts.TERTIARY_PURPLE,
        negative: n,
        iconOnly: !0,
        "data-testid": `${e}-trigger-button`,
        size: t,
        children: /* @__PURE__ */ g(an, { size: "md" })
      }
    );
    return /* @__PURE__ */ g("div", { "data-testid": e, className: m, children: /* @__PURE__ */ g(ma, { delayDuration: parseInt(_s), children: /* @__PURE__ */ H(ga, { open: h, onOpenChange: f, ...p, children: [
      /* @__PURE__ */ g(
        va,
        {
          asChild: !0,
          onClick: (_) => {
            _.preventDefault(), f(!0);
          },
          children: Ye.count(c) === 0 ? v : c
        }
      ),
      /* @__PURE__ */ g(ba, { children: /* @__PURE__ */ H(
        _a,
        {
          side: s,
          align: l,
          className: wt([
            i,
            `${me}__content`,
            `${me}__content--primary${n ? "-negative" : ""}`
          ]),
          sideOffset: -5,
          "data-testid": `${e}-content`,
          children: [
            typeof r == "string" ? /* @__PURE__ */ g(
              cn,
              {
                variant: un.PARAGRAPH100,
                negative: !n,
                "data-testid": `${e}-paragraph`,
                children: r
              }
            ) : r,
            /* @__PURE__ */ g(
              ya,
              {
                className: wt([
                  `${me}__arrow`,
                  `${me}__arrow--primary${n ? "-negative" : ""}`
                ])
              }
            )
          ]
        }
      ) })
    ] }) }) });
  }
);
Gn.displayName = "Tooltip";
const La = {
  name: "checkmark",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M21.06 3.795a.9.9 0 0 1 .145 1.264l-11.5 14.5a.9.9 0 0 1-1.341.077l-6-6a.9.9 0 0 1 1.272-1.272l5.286 5.286L19.795 3.94a.9.9 0 0 1 1.264-.145Z" clip-rule="evenodd"/></svg>',
  keywords: ["checkmark"],
  category: "utility"
}, Kn = (e) => /* @__PURE__ */ g(it, { ...e, svg: La });
Kn.displayName = "IconCheckmark";
function Ir(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function $a(...e) {
  return (t) => {
    let r = !1;
    const o = e.map((i) => {
      const n = Ir(i, t);
      return !r && typeof n == "function" && (r = !0), n;
    });
    if (r)
      return () => {
        for (let i = 0; i < o.length; i++) {
          const n = o[i];
          typeof n == "function" ? n() : Ir(e[i], null);
        }
      };
  };
}
var Zn = u.forwardRef((e, t) => {
  const { children: r, ...o } = e, i = u.Children.toArray(r), n = i.find(Ia);
  if (n) {
    const s = n.props.children, l = i.map((a) => a === n ? u.Children.count(s) > 1 ? u.Children.only(null) : u.isValidElement(s) ? s.props.children : null : a);
    return /* @__PURE__ */ g(Dt, { ...o, ref: t, children: u.isValidElement(s) ? u.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ g(Dt, { ...o, ref: t, children: r });
});
Zn.displayName = "Slot";
var Dt = u.forwardRef((e, t) => {
  const { children: r, ...o } = e;
  if (u.isValidElement(r)) {
    const i = ka(r), n = Ma(o, r.props);
    return r.type !== u.Fragment && (n.ref = t ? $a(t, i) : i), u.cloneElement(r, n);
  }
  return u.Children.count(r) > 1 ? u.Children.only(null) : null;
});
Dt.displayName = "SlotClone";
var Da = ({ children: e }) => /* @__PURE__ */ g(ke, { children: e });
function Ia(e) {
  return u.isValidElement(e) && e.type === Da;
}
function Ma(e, t) {
  const r = { ...t };
  for (const o in t) {
    const i = e[o], n = t[o];
    /^on[A-Z]/.test(o) ? i && n ? r[o] = (...s) => {
      n(...s), i(...s);
    } : i && (r[o] = i) : o === "style" ? r[o] = { ...i, ...n } : o === "className" && (r[o] = [i, n].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function ka(e) {
  var t, r;
  let o = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, i = o && "isReactWarning" in o && o.isReactWarning;
  return i ? e.ref : (o = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, i = o && "isReactWarning" in o && o.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var Fa = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Wa = Fa.reduce((e, t) => {
  const r = u.forwardRef((o, i) => {
    const { asChild: n, ...s } = o, l = n ? Zn : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(l, { ...s, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), ja = "VisuallyHidden", Jn = u.forwardRef(
  (e, t) => /* @__PURE__ */ g(
    Wa.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
Jn.displayName = ja;
var za = Jn;
const Ba = ({
  asChild: e,
  children: t,
  className: r = "",
  ["data-testid"]: o
}) => /* @__PURE__ */ g(za, { asChild: e, "data-testid": o, className: r, children: t }), Ha = {
  "purpur-stepper-button": "_purpur-stepper-button_1b0ie_1",
  "purpur-stepper-button__trigger-outline": "_purpur-stepper-button__trigger-outline_1b0ie_19",
  "purpur-stepper-button--first": "_purpur-stepper-button--first_1b0ie_31",
  "purpur-stepper-button--current": "_purpur-stepper-button--current_1b0ie_31",
  "purpur-stepper-button--middle": "_purpur-stepper-button--middle_1b0ie_36",
  "purpur-stepper-button--last": "_purpur-stepper-button--last_1b0ie_46",
  "purpur-stepper-button--visibility-small-screen": "_purpur-stepper-button--visibility-small-screen_1b0ie_56",
  "purpur-stepper-button--visibility-large-screen": "_purpur-stepper-button--visibility-large-screen_1b0ie_64",
  "purpur-stepper-button__icon": "_purpur-stepper-button__icon_1b0ie_84",
  "purpur-stepper-button__step-number": "_purpur-stepper-button__step-number_1b0ie_91",
  "purpur-stepper-button__step-number--current": "_purpur-stepper-button__step-number--current_1b0ie_102",
  "purpur-stepper-button__step-number--disabled": "_purpur-stepper-button__step-number--disabled_1b0ie_106",
  "purpur-stepper-button__step-label": "_purpur-stepper-button__step-label_1b0ie_111",
  "arrow-forward": "_arrow-forward_1b0ie_115",
  "purpur-stepper-button--primary": "_purpur-stepper-button--primary_1b0ie_127",
  "purpur-stepper-button--disabled": "_purpur-stepper-button--disabled_1b0ie_130",
  "purpur-stepper-button--secondary": "_purpur-stepper-button--secondary_1b0ie_136",
  "arrow-tail": "_arrow-tail_1b0ie_146",
  "sr-only--lg-down": "_sr-only--lg-down_1b0ie_165"
}, $e = ut.bind(Ha), B = "purpur-stepper-button", qa = ({
  ["data-testid"]: e,
  current: t,
  disabled: r,
  stepNumber: o
}) => /* @__PURE__ */ g(
  "div",
  {
    "data-testid": e,
    className: $e([
      `${B}__step-number`,
      {
        [`${B}__step-number--current`]: t
      },
      {
        [`${B}__step-number--disabled`]: r
      }
    ]),
    children: o
  }
), xt = ye(
  ({
    className: e,
    ["data-testid"]: t,
    variant: r,
    step: o,
    indexOfLastItem: i,
    index: n,
    currentStepIndex: s,
    whenToBeVisible: l,
    handleStepChange: a,
    handleStepFocus: c,
    completedStepLabel: p,
    ...d
  }, h) => {
    const f = n === 0 ? "first" : n === i ? "last" : "middle", m = n === s;
    return /* @__PURE__ */ g(di, { asChild: !0, children: /* @__PURE__ */ g(
      Ge,
      {
        ...d,
        ref: h,
        className: $e([
          e,
          B,
          `${B}--${f}`,
          `${B}--${r}`,
          `${B}--visibility-${l}`,
          {
            [`${B}--current`]: m
          },
          {
            [`${B}--disabled`]: o.disabled
          },
          {
            "arrow-tail": f !== "first"
          },
          {
            "arrow-forward": f !== "last"
          }
        ]),
        id: `stepper-trigger-button-${n}`,
        variant: Ct.TERTIARY_PURPLE,
        "data-testid": `${t}-step-trigger-item-${n}`,
        disabled: o.disabled,
        "aria-current": m && "step",
        onClick: (v) => a(v, n),
        onFocus: c,
        children: /* @__PURE__ */ H("span", { className: $e(`${B}__trigger-outline`), children: [
          o.finished && !m ? /* @__PURE__ */ g(
            Kn,
            {
              className: $e(`${B}__icon`),
              "data-testid": `${t}-step-finished-icon`,
              size: "sm"
            }
          ) : /* @__PURE__ */ g(
            qa,
            {
              "data-testid": `${t}-step-number`,
              current: m,
              disabled: o.disabled,
              stepNumber: n + 1
            }
          ),
          /* @__PURE__ */ H(
            "span",
            {
              className: $e([
                `${B}__step-label`,
                {
                  "sr-only--lg-down": !m
                }
              ]),
              children: [
                o.finished && /* @__PURE__ */ g(Ba, { children: p }),
                o.label
              ]
            }
          )
        ] })
      }
    ) });
  }
), Ua = {
  "purpur-stepper-nav-items__list": "_purpur-stepper-nav-items__list_1ph0j_1",
  "purpur-stepper-nav-items__list-item": "_purpur-stepper-nav-items__list-item_1ph0j_7",
  "purpur-stepper-nav-items__list-item--current": "_purpur-stepper-nav-items__list-item--current_1ph0j_21",
  "purpur-stepper-nav-items__tooltip-content": "_purpur-stepper-nav-items__tooltip-content_1ph0j_27",
  "purpur-stepper-nav-items__tooltip-trigger-item-container": "_purpur-stepper-nav-items__tooltip-trigger-item-container_1ph0j_30"
}, Ve = ut.bind(Ua), Le = "purpur-stepper-nav-items", Va = ye(
  ({
    ["data-testid"]: e,
    variant: t,
    handleStepChange: r,
    handleStepFocus: o,
    steps: i,
    firstStepRef: n,
    lastStepRef: s,
    currentStepIndex: l,
    completedStepLabel: a
  }, c) => {
    const p = i.map((d, h) => {
      const f = d.disabled ? /* @__PURE__ */ g("span", { className: Ve(`${Le}__tooltip-trigger-item-container`), children: /* @__PURE__ */ g(
        xt,
        {
          "data-testid": `${e}-disabled-sm`,
          variant: t,
          step: d,
          indexOfLastItem: i.length - 1,
          index: h,
          currentStepIndex: l,
          whenToBeVisible: _t.SMALL_SCREEN,
          completedStepLabel: a,
          handleStepChange: r,
          handleStepFocus: o
        }
      ) }) : null;
      return /* @__PURE__ */ g(
        "li",
        {
          className: Ve([
            `${Le}__list-item`,
            {
              [`${Le}__list-item--current`]: h === l
            }
          ]),
          ref: h === 0 ? n : h === i.length - 1 ? s : null,
          children: d.disabled ? /* @__PURE__ */ H(ke, { children: [
            /* @__PURE__ */ g(
              Gn,
              {
                contentClassName: Ve(`${Le}__tooltip-content`),
                triggerElement: f,
                children: d.label
              }
            ),
            /* @__PURE__ */ g(
              xt,
              {
                "data-testid": `${e}-disabled-lg`,
                variant: t,
                step: d,
                indexOfLastItem: i.length - 1,
                index: h,
                currentStepIndex: l,
                whenToBeVisible: _t.LARGE_SCREEN,
                completedStepLabel: a,
                handleStepChange: r,
                handleStepFocus: o
              }
            )
          ] }) : /* @__PURE__ */ g(
            xt,
            {
              "data-testid": e,
              variant: t,
              step: d,
              indexOfLastItem: i.length - 1,
              index: h,
              currentStepIndex: l,
              whenToBeVisible: _t.ALWAYS,
              completedStepLabel: a,
              handleStepChange: r,
              handleStepFocus: o
            }
          )
        },
        d.label
      );
    });
    return /* @__PURE__ */ g(Vr, { loop: !1, dir: "ltr", children: /* @__PURE__ */ g("ol", { ref: c, className: Ve(`${Le}__list`), children: p }) });
  }
), Ya = (e) => {
  const t = De(!0), r = De(null);
  return It(() => {
    !t.current && r.current !== null && r.current.focus(), t.current = !1;
  }, [e]), {
    contentRef: r
  };
}, ot = {
  LEFT: "left",
  RIGHT: "right"
}, Xa = () => {
  const e = De(null), t = De(null), r = De(null), [o, i] = St(!1), [n, s] = St(!1), l = (a) => {
    if (!e.current)
      return;
    const c = e.current, p = c.clientWidth, d = c.scrollLeft;
    a === ot.LEFT && c.scroll({
      behavior: "smooth",
      left: d - p / 2
    }), a === ot.RIGHT && c.scroll({
      behavior: "smooth",
      left: d + p / 2
    });
  };
  return It(() => {
    if (t.current && r.current) {
      const a = new IntersectionObserver(
        (c) => {
          for (const p of c) {
            if (p.target === t.current) {
              p.isIntersecting ? i(!1) : i(!0);
              continue;
            }
            p.target === r.current && (p.isIntersecting ? s(!1) : s(!0));
          }
        },
        { threshold: 0.95 }
      );
      a.observe(t.current), a.observe(r.current);
    }
  }, [t, r]), {
    scrollContainer: e,
    firstStepRef: t,
    lastStepRef: r,
    displayLeftScrollButton: o,
    displayRightScrollButton: n,
    handleHorizontalScroll: l
  };
}, re = ut.bind(ki), z = "purpur-stepper", Qn = ({
  ["aria-label"]: e,
  ["data-testid"]: t,
  children: r,
  className: o,
  completedStepLabel: i,
  currentStepIndex: n = 0,
  onStepChange: s,
  alignWithGrid: l = !1,
  leftScrollButtonAriaLabel: a,
  rightScrollButtonAriaLabel: c,
  variant: p = Mi.PRIMARY,
  ...d
}) => {
  const h = Ye.toArray(r).filter(zi), f = Ye.map(h, (R) => {
    const { disabled: E, finished: N, label: O } = R.props;
    return {
      disabled: E ?? !1,
      finished: N ?? !1,
      label: O
    };
  }), { contentRef: m } = Ya(n), {
    scrollContainer: v,
    firstStepRef: _,
    lastStepRef: b,
    displayLeftScrollButton: y,
    displayRightScrollButton: x,
    handleHorizontalScroll: w
  } = Xa(), S = re([
    o,
    z,
    {
      [`${z}--${p}`]: p
    }
  ]), A = (R) => {
    R.target.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center"
    });
  }, C = (R, E) => {
    R.preventDefault(), A(R), s(E);
  }, P = (R) => {
    A(R);
  };
  return /* @__PURE__ */ H("div", { className: S, ...d, children: [
    /* @__PURE__ */ g(Wi, { variant: p, alignWithGrid: l, children: /* @__PURE__ */ H("div", { className: re(`${z}__nav-container`), children: [
      /* @__PURE__ */ H(Ti, { children: [
        /* @__PURE__ */ g(Ni, { ref: v, children: /* @__PURE__ */ g(
          "nav",
          {
            "aria-label": e,
            "data-testid": t,
            className: re([
              `${z}__nav`,
              {
                [`${z}__nav--${p}`]: p
              }
            ]),
            children: /* @__PURE__ */ g(Vr, { loop: !1, dir: "ltr", children: /* @__PURE__ */ g(
              Va,
              {
                "data-testid": t,
                variant: p,
                firstStepRef: _,
                lastStepRef: b,
                steps: f,
                currentStepIndex: n,
                handleStepChange: C,
                handleStepFocus: P,
                completedStepLabel: i
              }
            ) })
          }
        ) }),
        /* @__PURE__ */ g(Oi, { orientation: "horizontal", children: /* @__PURE__ */ g(Li, {}) })
      ] }),
      y && /* @__PURE__ */ g(
        Ge,
        {
          "aria-label": a,
          className: re([
            `${z}__scroll-button`,
            `${z}__scroll-button--left`
          ]),
          variant: Ct.TERTIARY_PURPLE,
          tabIndex: -1,
          iconOnly: !0,
          onClick: () => {
            w(ot.LEFT);
          },
          children: /* @__PURE__ */ g(kr, { className: re(`${z}__scroll-button-icon`), size: "md" })
        }
      ),
      x && /* @__PURE__ */ g(
        Ge,
        {
          "aria-label": c,
          className: re([
            `${z}__scroll-button`,
            `${z}__scroll-button--right`
          ]),
          variant: Ct.TERTIARY_PURPLE,
          tabIndex: -1,
          iconOnly: !0,
          onClick: () => {
            w(ot.RIGHT);
          },
          children: /* @__PURE__ */ g(Fr, { className: re(`${z}__scroll-button-icon`), size: "md" })
        }
      )
    ] }) }),
    /* @__PURE__ */ g(
      "div",
      {
        tabIndex: -1,
        "aria-labelledby": `stepper-trigger-button-${n}`,
        ref: m,
        style: { outline: "none" },
        children: /* @__PURE__ */ g("div", { "aria-live": "polite", children: Ye.map(h, (R, E) => /* @__PURE__ */ g(
          "div",
          {
            className: re({
              [`${z}__hidden`]: E !== n
            }),
            hidden: E !== n,
            children: R
          }
        )) })
      }
    )
  ] });
};
Qn.Content = ji;
Qn.displayName = "Stepper";
export {
  Qn as Stepper
};
//# sourceMappingURL=stepper.es.js.map
